import React, { useState } from 'react'
const data1_line=[
    {
    id:1,
    plate:[
        {place:'y-point',top:30,left:90,rotate:0,h:60,w:1},
        {place:'x-bottom',top:90,left:90,rotate:0,h:1,w:60},
        {place:'x-top',top:30,left:90,rotate:0,h:1,w:60},
        {place:'y-side',top:30,left:150,rotate:0,h:60,w:1},
        {place:'y2-point',top:0,left:120,rotate:0,h:60,w:1},
        {place:'x2-bottom',top:60,left:120,rotate:0,h:1,w:61},
        {place:'x2-top',top:0,left:120,rotate:0,h:1,w:60},
        {place:'y2-side',top:0,left:180,rotate:0,h:60,w:1},
        {place:'x3-bottom',top:90,left:90,rotate:-45,h:1,w:43},
        {place:'x3-top',top:30,left:90,rotate:-45,h:1,w:43},
        {place:'x4-bottom',top:90,left:150,rotate:-45,h:1,w:43},
        {place:'x4-top',top:30,left:150,rotate:-45,h:1,w:43},
    ]
    },
    {
    id:2,
    plate:[
        {place:'y-point',top:30,left:90,rotate:0,h:60,w:1},
        {place:'x-bottom',top:90,left:90,rotate:15,h:1,w:54.3},
        {place:'x-top',top:30,left:90,rotate:15,h:1,w:54.3},
        {place:'y-side',top:44,left:142,rotate:0,h:60,w:1},
        {place:'y2-point',top:6,left:131,rotate:0,h:60,w:1},
        {place:'x2-bottom',top:66,left:132,rotate:15,h:1,w:54.3},
        {place:'x2-top',top:6,left:132,rotate:15,h:1,w:54.3},
        {place:'y2-side',top:20,left:184,rotate:0,h:60,w:1},
        {place:'x3-bottom',top:90,left:90,rotate:-30,h:1,w:48.6},
        {place:'x3-top',top:30,left:90,rotate:-30,h:1,w:48.6},
        {place:'x4-bottom',top:104,left:142,rotate:-30,h:1,w:48.6},
        {place:'x4-top',top:44,left:142,rotate:-30,h:1,w:48.6},
    ]
    },
    {
    id:3,
    plate:[
        {place:'y-point',top:30,left:90,rotate:0,h:60,w:1},
        {place:'x-bottom',top:90,left:90,rotate:30,h:1,w:48.6},
        {place:'x-top',top:30,left:90,rotate:30,h:1,w:48.6},
        {place:'y-side',top:55,left:131,rotate:0,h:60,w:1},
        {place:'y2-point',top:16,left:143,rotate:0,h:60,w:1},
        {place:'x2-bottom',top:76,left:143,rotate:30,h:1,w:48.6},
        {place:'x2-top',top:16,left:143,rotate:30,h:1,w:48.6},
        {place:'y2-side',top:40,left:184,rotate:0,h:60,w:1},
        {place:'x3-bottom',top:90,left:90,rotate:-15,h:1,w:54.3},
        {place:'x3-top',top:30,left:90,rotate:-15,h:1,w:54.3},
        {place:'x4-bottom',top:114,left:131,rotate:-15,h:1,w:54.3},
        {place:'x4-top',top:54,left:131,rotate:-15,h:1,w:54.3},
    ]
    },
    {
    id:4,
    plate:[
        {place:'y-point',top:30,left:90,rotate:0,h:60,w:1},
        {place:'x-bottom',top:90,left:90,rotate:45,h:1,w:43},
        {place:'x-top',top:30,left:90,rotate:45,h:1,w:43},
        {place:'y-side',top:60,left:120,rotate:0,h:60,w:1},
        {place:'y2-point',top:30,left:150,rotate:0,h:60,w:1},
        {place:'x2-bottom',top:90,left:150,rotate:45,h:1,w:43},
        {place:'x2-top',top:30,left:150,rotate:45,h:1,w:43},
        {place:'y2-side',top:60,left:179,rotate:0,h:60,w:1},
        {place:'x3-bottom',top:90,left:90,rotate:0,h:1,w:60},
        {place:'x3-top',top:30,left:90,rotate:0,h:1,w:60},
        {place:'x4-bottom',top:120,left:120,rotate:0,h:1,w:60},
        {place:'x4-top',top:60,left:120,rotate:0,h:1,w:60},
    ]
    },
    {
    id:5,
    plate:[
        {place:'y-point',top:30,left:90,rotate:0,h:60,w:1},
        {place:'x-bottom',top:90,left:90,rotate:-210,h:1,w:48.6},
        {place:'x-top',top:30,left:90,rotate:-210,h:1,w:48.6},
        {place:'y-side',top:53,left:48,rotate:0,h:60,w:1},
        {place:'y2-point',top:44,left:142,rotate:0,h:60,w:1},
        {place:'x2-bottom',top:104,left:142,rotate:-210,h:1,w:48.6},
        {place:'x2-top',top:46,left:142,rotate:-210,h:1,w:48.6},
        {place:'y2-side',top:68,left:99,rotate:0,h:60,w:1},
        {place:'x3-bottom',top:90,left:90,rotate:15,h:1,w:54.3},
        {place:'x3-top',top:30,left:90,rotate:15,h:1,w:54.3},
        {place:'x4-bottom',top:114,left:48,rotate:15,h:1,w:54.3},
        {place:'x4-top',top:54,left:47,rotate:15,h:1,w:54.3},
    ]
    },
    {
    id:6,
    plate:[
        {place:'y-point',top:30,left:90,rotate:0,h:60,w:1},
        {place:'x-bottom',top:90,left:90,rotate:-195,h:1,w:48.6},
        {place:'x-top',top:30,left:90,rotate:-195,h:1,w:48.6},
        {place:'y-side',top:42,left:42,rotate:0,h:60,w:1},
        {place:'y2-point',top:54,left:131,rotate:0,h:60,w:1},
        {place:'x2-bottom',top:115,left:131,rotate:-195,h:1,w:48.6},
        {place:'x2-top',top:55,left:132,rotate:-195,h:1,w:48.6},
        {place:'y2-side',top:66,left:84,rotate:0,h:60,w:1},
        {place:'x3-bottom',top:90,left:90,rotate:30,h:1,w:48.6},
        {place:'x3-top',top:30,left:90,rotate:30,h:1,w:48.6},
        {place:'x4-bottom',top:102,left:42,rotate:30,h:1,w:48.6},
        {place:'x4-top',top:42,left:42,rotate:30,h:1,w:48.6},
    ]
    },
    {
    id:7,
    plate:[
        {place:'y-point',top:30,left:90,rotate:0,h:60,w:1},
        {place:'x-bottom',top:90,left:90,rotate:-180,h:1,w:60},
        {place:'x-top',top:30,left:90,rotate:-180,h:1,w:60},
        {place:'y-side',top:30,left:30,rotate:0,h:60,w:1},
        {place:'y2-point',top:60,left:120,rotate:0,h:60,w:1},
        {place:'x2-bottom',top:121,left:120,rotate:-180,h:1,w:60},
        {place:'x2-top',top:62,left:120,rotate:-180,h:1,w:60},
        {place:'y2-side',top:60,left:60,rotate:0,h:60,w:1},
        {place:'x3-bottom',top:90,left:90,rotate:45,h:1,w:43},
        {place:'x3-top',top:30,left:90,rotate:45,h:1,w:43},
        {place:'x4-bottom',top:90,left:30,rotate:45,h:1,w:43},
        {place:'x4-top',top:30,left:30,rotate:45,h:1,w:43},
    ]
    },
    {
    id:8,
    plate:[
        {place:'y-point',top:30,left:90,rotate:0,h:60,w:1},
        {place:'x-bottom',top:90,left:90,rotate:195,h:1,w:54.3},
        {place:'x-top',top:30,left:90,rotate:195,h:1,w:54.3},
        {place:'y-side',top:16,left:37,rotate:0,h:60,w:1},
        {place:'y2-point',top:54,left:48,rotate:0,h:60,w:1},
        {place:'x2-bottom',top:114,left:48,rotate:195,h:1,w:54.3},
        {place:'x2-top',top:54,left:48,rotate:195,h:1,w:54.3},
        {place:'y2-side',top:39,left:-5,rotate:0,h:60,w:1},
        {place:'x3-bottom',top:90,left:90,rotate:150,h:1,w:48.6},
        {place:'x3-top',top:30,left:90,rotate:150,h:1,w:48.6},
        {place:'x4-bottom',top:76,left:38,rotate:150,h:1,w:48.6},
        {place:'x4-top',top:16,left:38,rotate:150,h:1,w:48.6},
    ]
    },
    {
    id:9,
    plate:[
        {place:'y-point',top:30,left:90,rotate:0,h:60,w:1},
        {place:'x-bottom',top:90,left:90,rotate:210,h:1,w:48.6},
        {place:'x-top',top:30,left:90,rotate:210,h:1,w:48.6},
        {place:'y-side',top:6,left:48,rotate:0,h:60,w:1},
        {place:'y2-point',top:44,left:37,rotate:0,h:60,w:1},
        {place:'x2-bottom',top:104,left:37,rotate:210,h:1,w:48.6},
        {place:'x2-top',top:46,left:38,rotate:210,h:1,w:48.6},
        {place:'y2-side',top:20,left:-5,rotate:0,h:60,w:1},
        {place:'x3-bottom',top:90,left:90,rotate:165,h:1,w:54.3},
        {place:'x3-top',top:31,left:90,rotate:165,h:1,w:54.3},
        {place:'x4-bottom',top:66,left:48,rotate:165,h:1,w:54.3},
        {place:'x4-top',top:7,left:48,rotate:165,h:1,w:54.3},
    ]
    },
    {
    id:10,
    plate:[
        {place:'y-point',top:30,left:90,rotate:0,h:60,w:1},
        {place:'x-bottom',top:90,left:90,rotate:225,h:1,w:43},
        {place:'x-top',top:30,left:90,rotate:225,h:1,w:43},
        {place:'y-side',top:0,left:60,rotate:0,h:60,w:1},
        {place:'y2-point',top:30,left:30,rotate:0,h:60,w:1},
        {place:'x2-bottom',top:90,left:30,rotate:225,h:1,w:43},
        {place:'x2-top',top:30,left:30,rotate:225,h:1,w:43},
        {place:'y2-side',top:0,left:0,rotate:0,h:60,w:1},
        {place:'x3-bottom',top:90,left:90,rotate:180,h:1,w:60},
        {place:'x3-top',top:30,left:90,rotate:180,h:1,w:60},
        {place:'x4-bottom',top:60,left:60,rotate:180,h:1,w:60},
        {place:'x4-top',top:0,left:60,rotate:180,h:1,w:60},
    ]
    },
    {
    id:11,
    plate:[
        {place:'y-point',top:30,left:90,rotate:0,h:60,w:1},
        {place:'x-bottom',top:90,left:90,rotate:-30,h:1,w:43},
        {place:'x-top',top:30,left:90,rotate:-30,h:1,w:43},
        {place:'y-side',top:-5,left:74,rotate:0,h:60,w:1},
        {place:'y2-point',top:16,left:38,rotate:0,h:60,w:1},
        {place:'x2-bottom',top:75,left:38,rotate:-30,h:1,w:43},
        {place:'x2-top',top:16,left:38,rotate:-30,h:1,w:43},
        {place:'y2-side',top:8,left:126,rotate:0,h:60,w:1},
        {place:'x3-bottom',top:90,left:90,rotate:195,h:1,w:54.3},
        {place:'x3-top',top:30,left:90,rotate:195,h:1,w:54.3},
        {place:'x4-bottom',top:69,left:128,rotate:195,h:1,w:54.3},
        {place:'x4-top',top:10,left:126,rotate:195,h:1,w:54.3},
    ]
    },
    {
    id:12,
    plate:[
        {place:'y-point',top:30,left:90,rotate:0,h:60,w:1},
        {place:'x-bottom',top:90,left:90,rotate:-15,h:1,w:54.3},
        {place:'x-top',top:30,left:90,rotate:-15,h:1,w:54.3},
        {place:'y-side',top:-9,left:100,rotate:0,h:60,w:1},
        {place:'y2-point',top:6,left:48,rotate:0,h:60,w:1},
        {place:'x2-bottom',top:65,left:48,rotate:-15,h:1,w:54.3},
        {place:'x2-top',top:6,left:48,rotate:-15,h:1,w:54.3},
        {place:'y2-side',top:16,left:142,rotate:0,h:60,w:1},
        {place:'x3-bottom',top:90,left:90,rotate:210,h:1,w:48.6},
        {place:'x3-top',top:30,left:90,rotate:210,h:1,w:48.6},
        {place:'x4-bottom',top:76,left:142,rotate:210,h:1,w:48.6},
        {place:'x4-top',top:17,left:143,rotate:210,h:1,w:48.6},
    ]
    },
    {
    id:13,
    plate:[
        {place:'y-point',top:30,left:90,rotate:0,h:60,w:1},
        {place:'x-bottom',top:90,left:90,rotate:360,h:1,w:60},
        {place:'x-top',top:30,left:90,rotate:360,h:1,w:60},
        {place:'y-side',top:30,left:150,rotate:0,h:60,w:1},
        {place:'y2-point',top:0,left:120,rotate:0,h:60,w:1},
        {place:'x2-bottom',top:60,left:120,rotate:360,h:1,w:60},
        {place:'x2-top',top:0,left:120,rotate:360,h:1,w:60},
        {place:'y2-side',top:0,left:180,rotate:0,h:60,w:1},
        {place:'x3-bottom',top:90,left:90,rotate:-45,h:1,w:43},
        {place:'x3-top',top:30,left:90,rotate:-45,h:1,w:43},
        {place:'x4-bottom',top:90,left:150,rotate:-45,h:1,w:43},
        {place:'x4-top',top:30,left:150,rotate:-45,h:1,w:43},
    ]
    },
    {
    id:14,
    plate:[
        {place:'y-point',top:36,left:90,rotate:15,h:54.3,w:1},//wall l
        {place:'x-bottom',top:90,left:90,rotate:0,h:1,w:60},
        {place:'x-top',top:38,left:104,rotate:0,h:1,w:60},//o
        {place:'y-side',top:36,left:148,rotate:15,h:54.3,w:1},//o
        {place:'y2-point',top:66,left:119,rotate:15,h:54.3,w:1},
        {place:'x2-bottom',top:120,left:120,rotate:0,h:1,w:60},//o
        {place:'x2-top',top:68,left:133,rotate:0,h:1,w:60},
        {place:'y2-side',top:66,left:179,rotate:15,h:54.3,w:1},//o
        {place:'x3-bottom',top:90,left:90,rotate:45,h:1,w:43},//wall l
        {place:'x3-top',top:38,left:104,rotate:45,h:1,w:43},//wall l 
        {place:'x4-bottom',top:90,left:150,rotate:45,h:1,w:43},//wall r
        {place:'x4-top',top:38,left:163,rotate:45,h:1,w:43},//wall r
    ]
    },
    {
    id:15,
    plate:[
        {place:'y-point',top:42,left:90,rotate:30,h:48.6,w:1},//ok
        {place:'x-bottom',top:90,left:90,rotate:0,h:1,w:60},//ok
        {place:'x-top',top:48,left:114,rotate:0,h:1,w:60},//ok
        {place:'y-side',top:42,left:148,rotate:30,h:48.6,w:1},//ok
        {place:'y2-point',top:87,left:102,rotate:30,h:48.6,w:1},//ok
        {place:'x2-bottom',top:136,left:102,rotate:0,h:1,w:60},//ok
        {place:'x2-top',top:94,left:126,rotate:0,h:1,w:60},
        {place:'y2-side',top:88,left:161,rotate:30,h:48.6,w:1},//ok
        {place:'x3-bottom',top:90,left:90,rotate:75,h:1,w:48.6},//ok
        {place:'x3-top',top:48,left:115,rotate:75,h:1,w:48.6},//ok
        {place:'x4-bottom',top:90,left:150,rotate:75,h:1,w:48.6},//wall r
        {place:'x4-top',top:48,left:173,rotate:75,h:1,w:48.6},//wall r
    ]
    },
    {
    id:16,
    plate:[
        {place:'y-point',top:48,left:90,rotate:45,h:43,w:1},
        {place:'x-bottom',top:90,left:150,rotate:90,h:1,w:60},
        {place:'x-top',top:60,left:120,rotate:0,h:1,w:60},
        {place:'y-side',top:48,left:149,rotate:45,h:43,w:1},
        {place:'y2-point',top:106,left:90,rotate:45,h:43,w:1},
        {place:'x2-bottom',top:90,left:90,rotate:90,h:1,w:60},
        {place:'x2-top',top:120,left:120,rotate:0,h:1,w:60},
        {place:'y2-side',top:106,left:149,rotate:45,h:43,w:1},
        {place:'x3-bottom',top:90,left:90,rotate:0,h:1,w:60},
        {place:'x3-top',top:60,left:120,rotate:90,h:1,w:60},
        {place:'x4-bottom',top:149,left:90,rotate:0,h:1,w:60},
        {place:'x4-top',top:60,left:180,rotate:90,h:1,w:60},
    ]
    },
    {
    id:17,
    plate:[
        {place:'y-point',top:38,left:90,rotate:-165,h:54.3,w:1},//top left
        {place:'x-bottom',top:132,left:114,rotate:0,h:1,w:60},//o
        {place:'x-top',top:90,left:89,rotate:0,h:1,w:60},
        {place:'y-side',top:36,left:148,rotate:-165,h:54.3,w:1},//top right
        {place:'y2-point',top:78,left:114,rotate:-165,h:54.3,w:1},//o
        {place:'x2-bottom',top:184,left:100,rotate:0,h:1,w:60},
        {place:'x2-top',top:144,left:76,rotate:0,h:1,w:60},//o
        {place:'y2-side',top:78,left:174,rotate:-165,h:54.3,w:1},//back right
        {place:'x3-bottom',top:90,left:90,rotate:-300,h:1,w:48.6},
        {place:'x3-top',top:144,left:75,rotate:-300,h:1,w:48.6},//o
        {place:'x4-bottom',top:90,left:150,rotate:-300,h:1,w:48.6},//o
        {place:'x4-top',top:142,left:134,rotate:-300,h:1,w:48.6},//o
    ]
    },
    {
    id:18,
    plate:[
        {place:'y-point',top:42,left:90,rotate:-150,h:48.6,w:1},
        {place:'x-bottom',top:90,left:90,rotate:0,h:1,w:60},
        {place:'x-top',top:184,left:79,rotate:0,h:1,w:60},
        {place:'y-side',top:42,left:148,rotate:-150,h:48.6,w:1},
        {place:'y2-point',top:94,left:104,rotate:-150,h:48.6,w:1},
        {place:'x2-bottom',top:142,left:104,rotate:0,h:1,w:60},
        {place:'x2-top',top:132,left:64,rotate:0,h:1,w:60},
        {place:'y2-side',top:94,left:164,rotate:-150,h:48.6,w:1},
        {place:'x3-bottom',top:90,left:90,rotate:-285,h:1,w:54.3},
        {place:'x3-top',top:132,left:65,rotate:-285,h:1,w:54.3},
        {place:'x4-bottom',top:90,left:150,rotate:-285,h:1,w:54.3},
        {place:'x4-top',top:132,left:124,rotate:-285,h:1,w:54.3},
    ]
    },
    {
    id:19,
    plate:[
        {place:'y-point',top:79,left:60,rotate:45,h:42,w:1},
        {place:'x-bottom',top:120,left:60,rotate:0,h:1,w:60},
        {place:'x-top',top:90,left:90,rotate:0,h:1,w:60},
        {place:'y-side',top:78,left:118,rotate:45,h:42,w:1},
        {place:'y2-point',top:138,left:60,rotate:45,h:43,w:1},
        {place:'x2-bottom',top:180,left:60,rotate:0,h:1,w:60},
        {place:'x2-top',top:150,left:90,rotate:0,h:1,w:60},
        {place:'y2-side',top:138,left:120,rotate:45,h:43,w:1},
        {place:'x3-bottom',top:120,left:60,rotate:-270,h:1,w:60},
        {place:'x3-top',top:91,left:91,rotate:-270,h:1,w:60},
        {place:'x4-bottom',top:120,left:120,rotate:-270,h:1,w:60},
        {place:'x4-top',top:91,left:150,rotate:-270,h:1,w:60},
    ]
    },
    {
    id:20,
    plate:[
        {place:'y-point',top:48,left:51,rotate:15,h:54.3,w:1},
        {place:'x-bottom',top:100,left:52,rotate:0,h:1,w:59},
        {place:'x-top',top:48,left:65,rotate:0,h:1,w:59},
        {place:'y-side',top:46,left:109,rotate:15,h:54.3,w:1},
        {place:'y2-point',top:88,left:76,rotate:15,h:54.3,w:1},
        {place:'x2-bottom',top:142,left:76,rotate:0,h:1,w:59},
        {place:'x2-top',top:90,left:90,rotate:0,h:1,w:60},
        {place:'y2-side',top:88,left:135,rotate:15,h:54.3,w:1},
        {place:'x3-bottom',top:100,left:52,rotate:-300,h:1,w:48.6},
        {place:'x3-top',top:48,left:66,rotate:-300,h:1,w:48.6},
        {place:'x4-bottom',top:100,left:110,rotate:-300,h:1,w:48.6},
        {place:'x4-top',top:48,left:124,rotate:-300,h:1,w:48.6},
    ]
    },
    {
    id:21,
    plate:[
        {place:'y-point',top:32,left:52,rotate:30,h:48.6,w:1},
        {place:'x-bottom',top:80,left:52,rotate:0,h:1,w:59},
        {place:'x-top',top:38,left:75,rotate:0,h:1,w:59},
        {place:'y-side',top:32,left:109,rotate:30,h:48.6,w:1},
        {place:'y2-point',top:84,left:66,rotate:30,h:48.6,w:1},
        {place:'x2-bottom',top:132,left:66,rotate:0,h:1,w:59},
        {place:'x2-top',top:90,left:90,rotate:0,h:1,w:60},
        {place:'y2-side',top:84,left:124,rotate:30,h:48.6,w:1},
        {place:'x3-bottom',top:80,left:53,rotate:-285,h:1,w:54.3},
        {place:'x3-top',top:38,left:76,rotate:-285,h:1,w:54.3},//y-point
        {place:'x4-bottom',top:79,left:110,rotate:-285,h:1,w:54.3},
        {place:'x4-top',top:38,left:135,rotate:-285,h:1,w:54.3},//y-side
    ]
    },
    {
    id:22,
    plate:[
        {place:'y-point',top:19,left:60,rotate:45,h:42,w:1},
        {place:'x-bottom',top:60,left:60,rotate:0,h:1,w:60},
        {place:'x-top',top:30,left:90,rotate:0,h:1,w:60},
        {place:'y-side',top:18,left:118,rotate:45,h:42,w:1},
        {place:'y2-point',top:78,left:60,rotate:45,h:43,w:1},
        {place:'x2-bottom',top:120,left:60,rotate:0,h:1,w:60},
        {place:'x2-top',top:90,left:90,rotate:0,h:1,w:60},
        {place:'y2-side',top:78,left:120,rotate:45,h:43,w:1},
        {place:'x3-bottom',top:60,left:60,rotate:-270,h:1,w:60},
        {place:'x3-top',top:31,left:91,rotate:-270,h:1,w:60},
        {place:'x4-bottom',top:60,left:120,rotate:-270,h:1,w:60},
        {place:'x4-top',top:31,left:150,rotate:-270,h:1,w:60},
    ]
    },
    {
    id:23,
    plate:[
        {place:'y-point',top:42,left:90,rotate:-30,h:48.6,w:1},
        {place:'x-bottom',top:90,left:90,rotate:0,h:1,w:60},
        {place:'x-top',top:48,left:66,rotate:0,h:1,w:60},
        {place:'y-side',top:42,left:149,rotate:-30,h:48.6,w:1},
        {place:'y2-point',top:-10,left:104,rotate:-30,h:48.6,w:1},
        {place:'x2-bottom',top:37,left:104,rotate:0,h:1,w:61},
        {place:'x2-top',top:-5,left:80,rotate:0,h:1,w:60},
        {place:'y2-side',top:-10,left:164,rotate:-30,h:48.6,w:1},
        {place:'x3-bottom',top:90,left:90,rotate:-75,h:1,w:54.3},
        {place:'x3-top',top:48,left:66,rotate:-75,h:1,w:54.3},
        {place:'x4-bottom',top:90,left:150,rotate:-75,h:1,w:54.3},
        {place:'x4-top',top:48,left:126,rotate:-75,h:1,w:54.3},
    ]
    },
    {
    id:24,
    plate:[
        {place:'y-point',top:35,left:90,rotate:-15,h:54.3,w:1},
        {place:'x-bottom',top:90,left:90,rotate:0,h:1,w:60},
        {place:'x-top',top:36,left:76,rotate:0,h:1,w:60},
        {place:'y-side',top:35,left:149,rotate:-15,h:54.3,w:1},
        {place:'y2-point',top:-6,left:114,rotate:-15,h:54.3,w:1},
        {place:'x2-bottom',top:48,left:114,rotate:0,h:1,w:59},
        {place:'x2-top',top:-5,left:100,rotate:0,h:1,w:60},
        {place:'y2-side',top:-6,left:173,rotate:-15,h:54.3,w:1},
        {place:'x3-bottom',top:90,left:90,rotate:-60,h:1,w:48.6},
        {place:'x3-top',top:37,left:76,rotate:-60,h:1,w:48.6},
        {place:'x4-bottom',top:90,left:149,rotate:-60,h:1,w:48.6},
        {place:'x4-top',top:37,left:134,rotate:-60,h:1,w:48.6},
    ]
    },
    {
    id:25,
    plate:[
        {place:'y-point',top:30,left:90,rotate:0,h:60,w:1},
        {place:'x-bottom',top:90,left:90,rotate:0,h:1,w:60},
        {place:'x-top',top:30,left:90,rotate:0,h:1,w:60},
        {place:'y-side',top:30,left:150,rotate:0,h:60,w:1},
        {place:'y2-point',top:0,left:120,rotate:0,h:60,w:1},
        {place:'x2-bottom',top:60,left:120,rotate:0,h:1,w:61},
        {place:'x2-top',top:0,left:120,rotate:0,h:1,w:60},
        {place:'y2-side',top:0,left:180,rotate:0,h:60,w:1},
        {place:'x3-bottom',top:90,left:90,rotate:-45,h:1,w:43},
        {place:'x3-top',top:30,left:90,rotate:-45,h:1,w:43},
        {place:'x4-bottom',top:90,left:150,rotate:-45,h:1,w:43},
        {place:'x4-top',top:30,left:150,rotate:-45,h:1,w:43},
    ]
    },
    {
    id:26,
    plate:[
        {place:'y-point',top:36,left:90,rotate:-15,h:54.3,w:1},
        {place:'x-bottom',top:89,left:90,rotate:15,h:1,w:54.3},
        {place:'x-top',top:38,left:76,rotate:15,h:1,w:54.3},
        {place:'y-side',top:50,left:142,rotate:-15,h:54.3,w:1},
        {place:'y2-point',top:2,left:124,rotate:-15,h:54.3,w:1},
        {place:'x2-bottom',top:56,left:124,rotate:15,h:1,w:54.3},
        {place:'x2-top',top:3,left:110,rotate:15,h:1,w:54.3},
        {place:'y2-side',top:17,left:176,rotate:-15,h:54.3,w:1},
        {place:'x3-bottom',top:90,left:90,rotate:-45,h:1,w:48.6},
        {place:'x3-top',top:38,left:75,rotate:-45,h:1,w:48.6},
        {place:'x4-bottom',top:104,left:142,rotate:-45,h:1,w:48.6},
        {place:'x4-top',top:52,left:128,rotate:-45,h:1,w:48.6},
    ]
    },
    {
    id:27,
    plate:[
        {place:'y-point',top:40,left:90,rotate:-30,h:48.6,w:1},
        {place:'x-bottom',top:88,left:90,rotate:30,h:1,w:48.6},
        {place:'x-top',top:46,left:66,rotate:30,h:1,w:48.6},
        {place:'y-side',top:64,left:131,rotate:-30,h:48.6,w:1},
        {place:'y2-point',top:2,left:128,rotate:-30,h:48.6,w:1},
        {place:'x2-bottom',top:50,left:128,rotate:30,h:1,w:48.6},
        {place:'x2-top',top:8,left:105,rotate:30,h:1,w:48.6},
        {place:'y2-side',top:26,left:170,rotate:-30,h:48.6,w:1},
        {place:'x3-bottom',top:90,left:90,rotate:-45,h:1,w:54.3},
        {place:'x3-top',top:46,left:66,rotate:-45,h:1,w:54.3},
        {place:'x4-bottom',top:112,left:131,rotate:-45,h:1,w:54.3},
        {place:'x4-top',top:71,left:108,rotate:-45,h:1,w:54.3},
    ]
    },
    {
    id:28,
    plate:[
        {place:'y-point',top:23,left:114,rotate:-30,h:48.6,w:1},
        {place:'x-bottom',top:27,left:88,rotate:30,h:1,w:48.6},
        {place:'x-top',top:66,left:50,rotate:30,h:1,w:48.6},
        {place:'y-side',top:84,left:114,rotate:-30,h:48.6,w:1},
        {place:'y2-point',top:60,left:74,rotate:-30,h:48.6,w:1},
        {place:'x2-bottom',top:108,left:74,rotate:30,h:1,w:48.6},
        {place:'x2-top',top:70,left:114,rotate:30,h:1,w:48.6},
        {place:'y2-side',top:45,left:153,rotate:-30,h:48.6,w:1},
        {place:'x3-bottom',top:110,left:75,rotate:-45,h:1,w:54.3},
        {place:'x3-top',top:66,left:50,rotate:-45,h:1,w:54.3},
        {place:'x4-bottom',top:132,left:116,rotate:-45,h:1,w:54.3},
        {place:'x4-top',top:90,left:90,rotate:-45,h:1,w:54.3},
    ]
    },
    {
    id:29,
    plate:[
        {place:'y-point',top:75,left:51,rotate:-15,h:54.3,w:1},
        {place:'x-bottom',top:129,left:51,rotate:15,h:1,w:54.3},
        {place:'x-top',top:76,left:37,rotate:15,h:1,w:54.3},
        {place:'y-side',top:88,left:102,rotate:-15,h:54.3,w:1},
        {place:'y2-point',top:40,left:86,rotate:-15,h:55.3,w:1},
        {place:'x2-bottom',top:96,left:85,rotate:15,h:1,w:54.3},
        {place:'x2-top',top:42,left:72,rotate:15,h:1,w:54.3},
        {place:'y2-side',top:54,left:137,rotate:-15,h:55.3,w:1},
        {place:'x3-bottom',top:130,left:51,rotate:-45,h:1,w:48.6},
        {place:'x3-top',top:76,left:38,rotate:-45,h:1,w:48.6},
        {place:'x4-bottom',top:144,left:102,rotate:-45,h:1,w:48.6},
        {place:'x4-top',top:91,left:88,rotate:-45,h:1,w:48.6},
    ]
    },
    {
    id:30,
    plate:[
        {place:'y-point',top:90,left:30,rotate:0,h:60,w:1},
        {place:'x-bottom',top:150,left:30,rotate:0,h:1,w:60},
        {place:'x-top',top:90,left:30,rotate:0,h:1,w:60},
        {place:'y-side',top:90,left:90,rotate:0,h:60,w:1},
        {place:'y2-point',top:60,left:60,rotate:0,h:60,w:1},
        {place:'x2-bottom',top:120,left:60,rotate:0,h:1,w:61},
        {place:'x2-top',top:60,left:60,rotate:0,h:1,w:60},
        {place:'y2-side',top:60,left:120,rotate:0,h:60,w:1},
        {place:'x3-bottom',top:150,left:30,rotate:-45,h:1,w:43},
        {place:'x3-top',top:90,left:30,rotate:-45,h:1,w:43},
        {place:'x4-bottom',top:150,left:90,rotate:-45,h:1,w:43},
        {place:'x4-top',top:90,left:90,rotate:-45,h:1,w:43},
    ]
    },
    {
    id:31,
    plate:[
        {place:'y-point',top:75,left:51,rotate:-15,h:54.3,w:1},
        {place:'x-bottom',top:129,left:51,rotate:15,h:1,w:54.3},
        {place:'x-top',top:76,left:37,rotate:15,h:1,w:54.3},
        {place:'y-side',top:88,left:102,rotate:-15,h:54.3,w:1},
        {place:'y2-point',top:40,left:86,rotate:-15,h:55.3,w:1},
        {place:'x2-bottom',top:96,left:85,rotate:15,h:1,w:54.3},
        {place:'x2-top',top:42,left:72,rotate:15,h:1,w:54.3},
        {place:'y2-side',top:54,left:137,rotate:-15,h:55.3,w:1},
        {place:'x3-bottom',top:130,left:51,rotate:-45,h:1,w:48.6},
        {place:'x3-top',top:76,left:38,rotate:-45,h:1,w:48.6},
        {place:'x4-bottom',top:144,left:102,rotate:-45,h:1,w:48.6},
        {place:'x4-top',top:91,left:88,rotate:-45,h:1,w:48.6},
    ]
    },
    {
    id:32,
    plate:[
         {place:'y-point',top:23,left:114,rotate:-30,h:48.6,w:1},
        {place:'x-bottom',top:27,left:88,rotate:30,h:1,w:48.6},
        {place:'x-top',top:66,left:50,rotate:30,h:1,w:48.6},
        {place:'y-side',top:84,left:114,rotate:-30,h:48.6,w:1},
        {place:'y2-point',top:60,left:74,rotate:-30,h:48.6,w:1},
        {place:'x2-bottom',top:108,left:74,rotate:30,h:1,w:48.6},
        {place:'x2-top',top:70,left:114,rotate:30,h:1,w:48.6},
        {place:'y2-side',top:45,left:153,rotate:-30,h:48.6,w:1},
        {place:'x3-bottom',top:110,left:75,rotate:-45,h:1,w:54.3},
        {place:'x3-top',top:66,left:50,rotate:-45,h:1,w:54.3},
        {place:'x4-bottom',top:132,left:116,rotate:-45,h:1,w:54.3},
        {place:'x4-top',top:90,left:90,rotate:-45,h:1,w:54.3},
    ]
    },
    {
    id:33,
    plate:[
        {place:'y-point',top:40,left:90,rotate:-30,h:48.6,w:1},
        {place:'x-bottom',top:88,left:90,rotate:30,h:1,w:48.6},
        {place:'x-top',top:46,left:66,rotate:30,h:1,w:48.6},
        {place:'y-side',top:64,left:131,rotate:-30,h:48.6,w:1},
        {place:'y2-point',top:2,left:128,rotate:-30,h:48.6,w:1},
        {place:'x2-bottom',top:50,left:128,rotate:30,h:1,w:48.6},
        {place:'x2-top',top:8,left:105,rotate:30,h:1,w:48.6},
        {place:'y2-side',top:26,left:170,rotate:-30,h:48.6,w:1},
        {place:'x3-bottom',top:90,left:90,rotate:-45,h:1,w:54.3},
        {place:'x3-top',top:46,left:66,rotate:-45,h:1,w:54.3},
        {place:'x4-bottom',top:112,left:131,rotate:-45,h:1,w:54.3},
        {place:'x4-top',top:71,left:108,rotate:-45,h:1,w:54.3},
    ]
    },
    {
    id:34,
    plate:[
        {place:'y-point',top:36,left:90,rotate:-15,h:54.3,w:1},
        {place:'x-bottom',top:89,left:90,rotate:15,h:1,w:54.3},
        {place:'x-top',top:38,left:76,rotate:15,h:1,w:54.3},
        {place:'y-side',top:50,left:142,rotate:-15,h:54.3,w:1},
        {place:'y2-point',top:2,left:124,rotate:-15,h:54.3,w:1},
        {place:'x2-bottom',top:56,left:124,rotate:15,h:1,w:54.3},
        {place:'x2-top',top:3,left:110,rotate:15,h:1,w:54.3},
        {place:'y2-side',top:17,left:176,rotate:-15,h:54.3,w:1},
        {place:'x3-bottom',top:90,left:90,rotate:-45,h:1,w:48.6},
        {place:'x3-top',top:38,left:75,rotate:-45,h:1,w:48.6},
        {place:'x4-bottom',top:104,left:142,rotate:-45,h:1,w:48.6},
        {place:'x4-top',top:52,left:128,rotate:-45,h:1,w:48.6},
    ]
    },
    {
    id:35,
    plate:[
        {place:'y-point',top:36,left:90,rotate:-15,h:54.3,w:1},
        {place:'x-bottom',top:89,left:90,rotate:15,h:1,w:54.3},
        {place:'x-top',top:38,left:76,rotate:15,h:1,w:54.3},
        {place:'y-side',top:50,left:142,rotate:-15,h:54.3,w:1},
        {place:'y2-point',top:2,left:124,rotate:-15,h:54.3,w:1},
        {place:'x2-bottom',top:56,left:124,rotate:15,h:1,w:54.3},
        {place:'x2-top',top:3,left:110,rotate:15,h:1,w:54.3},
        {place:'y2-side',top:17,left:176,rotate:-15,h:54.3,w:1},
        {place:'x3-bottom',top:90,left:90,rotate:-45,h:1,w:48.6},
        {place:'x3-top',top:38,left:75,rotate:-45,h:1,w:48.6},
        {place:'x4-bottom',top:104,left:142,rotate:-45,h:1,w:48.6},
        {place:'x4-top',top:52,left:128,rotate:-45,h:1,w:48.6},
    ]
    },
    {
    id:36,
    plate:[
        {place:'y-point',top:30,left:90,rotate:0,h:60,w:1},
        {place:'x-bottom',top:90,left:90,rotate:0,h:1,w:60},
        {place:'x-top',top:30,left:90,rotate:0,h:1,w:60},
        {place:'y-side',top:30,left:150,rotate:0,h:60,w:1},
        {place:'y2-point',top:0,left:120,rotate:0,h:60,w:1},
        {place:'x2-bottom',top:60,left:120,rotate:0,h:1,w:61},
        {place:'x2-top',top:0,left:120,rotate:0,h:1,w:60},
        {place:'y2-side',top:0,left:180,rotate:0,h:60,w:1},
        {place:'x3-bottom',top:90,left:90,rotate:-45,h:1,w:43},
        {place:'x3-top',top:30,left:90,rotate:-45,h:1,w:43},
        {place:'x4-bottom',top:90,left:150,rotate:-45,h:1,w:43},
        {place:'x4-top',top:30,left:150,rotate:-45,h:1,w:43},
    ]
    },
]
const data1_plate = [
    {
        id:1,
        items:[
        {"left":0,"top":0,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":0,"rotatey":0,"maxh":60,"maxw":60},
        {"left":3,"top":3,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":0,"rotatey":0,"maxh":60,"maxw":60},
        {"left":6,"top":6,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":0,"rotatey":0,"maxh":60,"maxw":60},
        {"left":9,"top":9,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":0,"rotatey":0,"maxh":60,"maxw":60},
        {"left":12,"top":12,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":0,"rotatey":0,"maxh":60,"maxw":60},
        {"left":15,"top":15,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":0,"rotatey":0,"maxh":60,"maxw":60},
        {"left":18,"top":18,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":0,"rotatey":0,"maxh":60,"maxw":60},
        {"left":21,"top":21,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":0,"rotatey":0,"maxh":60,"maxw":60},
        {"left":24,"top":24,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":0,"rotatey":0,"maxh":60,"maxw":60},
        {"left":27,"top":27,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":0,"rotatey":0,"maxh":60,"maxw":60},
        {"left":30,"top":30,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":0,"rotatey":0,"maxh":60,"maxw":60}
        ]
    },
    {
        id:2,
        items:[
        {"left":-12,"top":6,"rotate":0,"h":60,"w":68,"skewx":0,"skewy":15,"rotatex":0,"rotatey":0,"maxh":60,"maxw":48},
        {"left":-8,"top":8,"rotate":0,"h":60,"w":68,"skewx":0,"skewy":15,"rotatex":0,"rotatey":0,"maxh":60,"maxw":48},
        {"left":-4,"top":10,"rotate":0,"h":60,"w":68,"skewx":0,"skewy":15,"rotatex":0,"rotatey":0,"maxh":60,"maxw":48},
        {"left":0,"top":13,"rotate":0,"h":60,"w":68,"skewx":0,"skewy":15,"rotatex":0,"rotatey":0,"maxh":60,"maxw":48},
        {"left":4,"top":15,"rotate":0,"h":60,"w":68,"skewx":0,"skewy":15,"rotatex":0,"rotatey":0,"maxh":60,"maxw":48},
        {"left":9,"top":18,"rotate":0,"h":60,"w":68,"skewx":0,"skewy":15,"rotatex":0,"rotatey":0,"maxh":60,"maxw":48},
        {"left":13,"top":20,"rotate":0,"h":60,"w":68,"skewx":0,"skewy":15,"rotatex":0,"rotatey":0,"maxh":60,"maxw":48},
        {"left":17,"top":22,"rotate":0,"h":60,"w":68,"skewx":0,"skewy":15,"rotatex":0,"rotatey":0,"maxh":60,"maxw":48},
        {"left":21,"top":25,"rotate":0,"h":60,"w":68,"skewx":0,"skewy":15,"rotatex":0,"rotatey":0,"maxh":60,"maxw":48},
        {"left":25,"top":27,"rotate":0,"h":60,"w":68,"skewx":0,"skewy":15,"rotatex":0,"rotatey":0,"maxh":60,"maxw":48},
        {"left":30,"top":30,"rotate":0,"h":60,"w":68,"skewx":0,"skewy":15,"rotatex":0,"rotatey":0,"maxh":60,"maxw":48}
        ]
    },
    {
        id:3,
        items:[
        {"left":-24,"top":18,"rotate":0,"h":60,"w":78,"skewx":0,"skewy":30,"rotatex":0,"rotatey":0,"maxh":60,"maxw":40},
        {"left":-19,"top":19,"rotate":0,"h":60,"w":78,"skewx":0,"skewy":30,"rotatex":0,"rotatey":0,"maxh":60,"maxw":40},
        {"left":-14,"top":20,"rotate":0,"h":60,"w":78,"skewx":0,"skewy":30,"rotatex":0,"rotatey":0,"maxh":60,"maxw":40},
        {"left":-8,"top":21,"rotate":0,"h":60,"w":78,"skewx":0,"skewy":30,"rotatex":0,"rotatey":0,"maxh":60,"maxw":40},
        {"left":-3,"top":22,"rotate":0,"h":60,"w":78,"skewx":0,"skewy":30,"rotatex":0,"rotatey":0,"maxh":60,"maxw":40},
        {"left":3,"top":24,"rotate":0,"h":60,"w":78,"skewx":0,"skewy":30,"rotatex":0,"rotatey":0,"maxh":60,"maxw":40},
        {"left":8,"top":25,"rotate":0,"h":60,"w":78,"skewx":0,"skewy":30,"rotatex":0,"rotatey":0,"maxh":60,"maxw":40},
        {"left":13,"top":26,"rotate":0,"h":60,"w":78,"skewx":0,"skewy":30,"rotatex":0,"rotatey":0,"maxh":60,"maxw":40},
        {"left":19,"top":27,"rotate":0,"h":60,"w":78,"skewx":0,"skewy":30,"rotatex":0,"rotatey":0,"maxh":60,"maxw":40},
        {"left":24,"top":28,"rotate":0,"h":60,"w":78,"skewx":0,"skewy":30,"rotatex":0,"rotatey":0,"maxh":60,"maxw":40},
        {"left":30,"top":30,"rotate":0,"h":60,"w":78,"skewx":0,"skewy":30,"rotatex":0,"rotatey":0,"maxh":60,"maxw":40}
        ]
    },
    {
        id:4,
        items:[
        {"left":-30,"top":30,"rotate":0,"h":60,"w":90,"skewx":0,"skewy":45,"rotatex":0,"rotatey":0,"maxh":60,"maxw":30},
        {"left":-24,"top":30,"rotate":0,"h":60,"w":90,"skewx":0,"skewy":45,"rotatex":0,"rotatey":0,"maxh":60,"maxw":30},
        {"left":-18,"top":30,"rotate":0,"h":60,"w":90,"skewx":0,"skewy":45,"rotatex":0,"rotatey":0,"maxh":60,"maxw":30},
        {"left":-12,"top":30,"rotate":0,"h":60,"w":90,"skewx":0,"skewy":45,"rotatex":0,"rotatey":0,"maxh":60,"maxw":30},
        {"left":-6,"top":30,"rotate":0,"h":60,"w":90,"skewx":0,"skewy":45,"rotatex":0,"rotatey":0,"maxh":60,"maxw":30},
        {"left":0,"top":30,"rotate":0,"h":60,"w":90,"skewx":0,"skewy":45,"rotatex":0,"rotatey":0,"maxh":60,"maxw":30},
        {"left":6,"top":30,"rotate":0,"h":60,"w":90,"skewx":0,"skewy":45,"rotatex":0,"rotatey":0,"maxh":60,"maxw":30},
        {"left":12,"top":30,"rotate":0,"h":60,"w":90,"skewx":0,"skewy":45,"rotatex":0,"rotatey":0,"maxh":60,"maxw":30},
        {"left":18,"top":30,"rotate":0,"h":60,"w":90,"skewx":0,"skewy":45,"rotatex":0,"rotatey":0,"maxh":60,"maxw":30},
        {"left":24,"top":30,"rotate":0,"h":60,"w":90,"skewx":0,"skewy":45,"rotatex":0,"rotatey":0,"maxh":60,"maxw":30},
        {"left":30,"top":30,"rotate":0,"h":60,"w":90,"skewx":0,"skewy":45,"rotatex":0,"rotatey":0,"maxh":60,"maxw":30}
        ]
    },
    {
        id:5,
        items:[
        {"left":-22,"top":44,"rotate":0,"h":60,"w":78,"skewx":0,"skewy":-30,"rotatex":0,"rotatey":180,"maxh":60,"maxw":40},
        {"left":-17,"top":44,"rotate":0,"h":60,"w":78,"skewx":0,"skewy":-30,"rotatex":0,"rotatey":180,"maxh":60,"maxw":40},
        {"left":-12,"top":42,"rotate":0,"h":60,"w":78,"skewx":0,"skewy":-30,"rotatex":0,"rotatey":180,"maxh":60,"maxw":40},
        {"left":-7,"top":41,"rotate":0,"h":60,"w":78,"skewx":0,"skewy":-30,"rotatex":0,"rotatey":180,"maxh":60,"maxw":40},
        {"left":-2,"top":39,"rotate":0,"h":60,"w":78,"skewx":0,"skewy":-30,"rotatex":0,"rotatey":180,"maxh":60,"maxw":40},
        {"left":4,"top":38,"rotate":0,"h":60,"w":78,"skewx":0,"skewy":-30,"rotatex":0,"rotatey":180,"maxh":60,"maxw":40},
        {"left":9,"top":36,"rotate":0,"h":60,"w":78,"skewx":0,"skewy":-30,"rotatex":0,"rotatey":180,"maxh":60,"maxw":40},
        {"left":14,"top":34,"rotate":0,"h":60,"w":78,"skewx":0,"skewy":-30,"rotatex":0,"rotatey":180,"maxh":60,"maxw":40},
        {"left":19,"top":33,"rotate":0,"h":60,"w":78,"skewx":0,"skewy":-30,"rotatex":0,"rotatey":180,"maxh":60,"maxw":40},
        {"left":24,"top":31,"rotate":0,"h":60,"w":78,"skewx":0,"skewy":-30,"rotatex":0,"rotatey":180,"maxh":60,"maxw":40},
        {"left":30,"top":30,"rotate":0,"h":60,"w":78,"skewx":0,"skewy":-30,"rotatex":0,"rotatey":180,"maxh":60,"maxw":40}
        ]
    },
    {
        id:6,
        items:[
        {"left":-12,"top":54,"rotate":0,"h":60,"w":72,"skewx":0,"skewy":-15,"rotatex":0,"rotatey":-180,"maxh":60,"maxw":46},
        {"left":-8,"top":51,"rotate":0,"h":60,"w":72,"skewx":0,"skewy":-15,"rotatex":0,"rotatey":-180,"maxh":60,"maxw":46},
        {"left":-4,"top":49,"rotate":0,"h":60,"w":72,"skewx":0,"skewy":-15,"rotatex":0,"rotatey":-180,"maxh":60,"maxw":46},
        {"left":0,"top":46,"rotate":0,"h":60,"w":72,"skewx":0,"skewy":-15,"rotatex":0,"rotatey":-180,"maxh":60,"maxw":46},
        {"left":4,"top":44,"rotate":0,"h":60,"w":72,"skewx":0,"skewy":-15,"rotatex":0,"rotatey":-180,"maxh":60,"maxw":46},
        {"left":9,"top":42,"rotate":0,"h":60,"w":72,"skewx":0,"skewy":-15,"rotatex":0,"rotatey":-180,"maxh":60,"maxw":46},
        {"left":13,"top":39,"rotate":0,"h":60,"w":72,"skewx":0,"skewy":-15,"rotatex":0,"rotatey":-180,"maxh":60,"maxw":46},
        {"left":17,"top":37,"rotate":0,"h":60,"w":72,"skewx":0,"skewy":-15,"rotatex":0,"rotatey":-180,"maxh":60,"maxw":46},
        {"left":21,"top":34,"rotate":0,"h":60,"w":72,"skewx":0,"skewy":-15,"rotatex":0,"rotatey":-180,"maxh":60,"maxw":46},
        {"left":25,"top":32,"rotate":0,"h":60,"w":72,"skewx":0,"skewy":-15,"rotatex":0,"rotatey":-180,"maxh":60,"maxw":46},
        {"left":30,"top":30,"rotate":0,"h":60,"w":72,"skewx":0,"skewy":-15,"rotatex":0,"rotatey":-180,"maxh":60,"maxw":46}
        ]
    },
    {
        id:7,
        items:[
        {"left":0,"top":60,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":0,"rotatey":-180,"maxh":60,"maxw":60},
        {"left":3,"top":57,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":0,"rotatey":-180,"maxh":60,"maxw":60},
        {"left":6,"top":54,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":0,"rotatey":-180,"maxh":60,"maxw":60},
        {"left":9,"top":51,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":0,"rotatey":-180,"maxh":60,"maxw":60},
        {"left":12,"top":48,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":0,"rotatey":-180,"maxh":60,"maxw":60},
        {"left":15,"top":45,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":0,"rotatey":-180,"maxh":60,"maxw":60},
        {"left":18,"top":42,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":0,"rotatey":-180,"maxh":60,"maxw":60},
        {"left":21,"top":39,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":0,"rotatey":-180,"maxh":60,"maxw":60},
        {"left":24,"top":36,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":0,"rotatey":-180,"maxh":60,"maxw":60},
        {"left":27,"top":33,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":0,"rotatey":-180,"maxh":60,"maxw":60},
        {"left":30,"top":30,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":0,"rotatey":-180,"maxh":60,"maxw":60}
        ]
    },
    {
        id:8,
        items:[
        {"left":72,"top":54,"rotate":0,"h":60,"w":68,"skewx":0,"skewy":15,"rotatex":0,"rotatey":-180,"maxh":60,"maxw":52},
        {"left":67,"top":51,"rotate":0,"h":60,"w":68,"skewx":0,"skewy":15,"rotatex":0,"rotatey":-180,"maxh":60,"maxw":52},
        {"left":63,"top":49,"rotate":0,"h":60,"w":68,"skewx":0,"skewy":15,"rotatex":0,"rotatey":-180,"maxh":60,"maxw":52},
        {"left":59,"top":46,"rotate":0,"h":60,"w":68,"skewx":0,"skewy":15,"rotatex":0,"rotatey":-180,"maxh":60,"maxw":52},
        {"left":55,"top":44,"rotate":0,"h":60,"w":68,"skewx":0,"skewy":15,"rotatex":0,"rotatey":-180,"maxh":60,"maxw":52},
        {"left":51,"top":42,"rotate":0,"h":60,"w":68,"skewx":0,"skewy":15,"rotatex":0,"rotatey":-180,"maxh":60,"maxw":52},
        {"left":46,"top":39,"rotate":0,"h":60,"w":68,"skewx":0,"skewy":15,"rotatex":0,"rotatey":-180,"maxh":60,"maxw":52},
        {"left":42,"top":37,"rotate":0,"h":60,"w":68,"skewx":0,"skewy":15,"rotatex":0,"rotatey":-180,"maxh":60,"maxw":52},
        {"left":38,"top":34,"rotate":0,"h":60,"w":68,"skewx":0,"skewy":15,"rotatex":0,"rotatey":-180,"maxh":60,"maxw":52},
        {"left":34,"top":32,"rotate":0,"h":60,"w":68,"skewx":0,"skewy":15,"rotatex":0,"rotatey":-180,"maxh":60,"maxw":52},
        {"left":30,"top":30,"rotate":0,"h":60,"w":68,"skewx":0,"skewy":15,"rotatex":0,"rotatey":-180,"maxh":60,"maxw":52}
        ]
    },
    {
        id:9,
        items:[
        {"left":82,"top":44,"rotate":0,"h":60,"w":78,"skewx":0,"skewy":30,"rotatex":0,"rotatey":-180,"maxh":60,"maxw":42},
        {"left":76,"top":42,"rotate":0,"h":60,"w":78,"skewx":0,"skewy":30,"rotatex":0,"rotatey":-180,"maxh":60,"maxw":42},
        {"left":71,"top":41,"rotate":0,"h":60,"w":78,"skewx":0,"skewy":30,"rotatex":0,"rotatey":-180,"maxh":60,"maxw":42},
        {"left":66,"top":39,"rotate":0,"h":60,"w":78,"skewx":0,"skewy":30,"rotatex":0,"rotatey":-180,"maxh":60,"maxw":42},
        {"left":61,"top":38,"rotate":0,"h":60,"w":78,"skewx":0,"skewy":30,"rotatex":0,"rotatey":-180,"maxh":60,"maxw":42},
        {"left":56,"top":37,"rotate":0,"h":60,"w":78,"skewx":0,"skewy":30,"rotatex":0,"rotatey":-180,"maxh":60,"maxw":42},
        {"left":50,"top":35,"rotate":0,"h":60,"w":78,"skewx":0,"skewy":30,"rotatex":0,"rotatey":-180,"maxh":60,"maxw":42},
        {"left":45,"top":34,"rotate":0,"h":60,"w":78,"skewx":0,"skewy":30,"rotatex":0,"rotatey":-180,"maxh":60,"maxw":42},
        {"left":40,"top":32,"rotate":0,"h":60,"w":78,"skewx":0,"skewy":30,"rotatex":0,"rotatey":-180,"maxh":60,"maxw":42},
        {"left":35,"top":31,"rotate":0,"h":60,"w":78,"skewx":0,"skewy":30,"rotatex":0,"rotatey":-180,"maxh":60,"maxw":42},
        {"left":30,"top":30,"rotate":0,"h":60,"w":78,"skewx":0,"skewy":30,"rotatex":0,"rotatey":-180,"maxh":60,"maxw":42}
        ]
    },
    {
        id:10,
        items:[
        {"left":90,"top":30,"rotate":0,"h":60,"w":90,"skewx":0,"skewy":45,"rotatex":0,"rotatey":-180,"maxh":60,"maxw":30},
        {"left":84,"top":30,"rotate":0,"h":60,"w":90,"skewx":0,"skewy":45,"rotatex":0,"rotatey":-180,"maxh":60,"maxw":30},
        {"left":78,"top":30,"rotate":0,"h":60,"w":90,"skewx":0,"skewy":45,"rotatex":0,"rotatey":-180,"maxh":60,"maxw":30},
        {"left":72,"top":30,"rotate":0,"h":60,"w":90,"skewx":0,"skewy":45,"rotatex":0,"rotatey":-180,"maxh":60,"maxw":30},
        {"left":66,"top":30,"rotate":0,"h":60,"w":90,"skewx":0,"skewy":45,"rotatex":0,"rotatey":-180,"maxh":60,"maxw":30},
        {"left":60,"top":30,"rotate":0,"h":60,"w":90,"skewx":0,"skewy":45,"rotatex":0,"rotatey":-180,"maxh":60,"maxw":30},
        {"left":54,"top":30,"rotate":0,"h":60,"w":90,"skewx":0,"skewy":45,"rotatex":0,"rotatey":-180,"maxh":60,"maxw":30},
        {"left":48,"top":30,"rotate":0,"h":60,"w":90,"skewx":0,"skewy":45,"rotatex":0,"rotatey":-180,"maxh":60,"maxw":30},
        {"left":42,"top":30,"rotate":0,"h":60,"w":90,"skewx":0,"skewy":45,"rotatex":0,"rotatey":-180,"maxh":60,"maxw":30},
        {"left":36,"top":30,"rotate":0,"h":60,"w":90,"skewx":0,"skewy":45,"rotatex":0,"rotatey":-180,"maxh":60,"maxw":30},
        {"left":30,"top":30,"rotate":0,"h":60,"w":90,"skewx":0,"skewy":45,"rotatex":0,"rotatey":-180,"maxh":60,"maxw":30}
        ]
    },
    {
        id:11,
        items:[
        {"left":84,"top":18,"rotate":0,"h":60,"w":82,"skewx":0,"skewy":-30,"rotatex":0,"rotatey":0,"maxh":60,"maxw":36},
        {"left":78,"top":19,"rotate":0,"h":60,"w":82,"skewx":0,"skewy":-30,"rotatex":0,"rotatey":0,"maxh":60,"maxw":36},
        {"left":73,"top":20,"rotate":0,"h":60,"w":82,"skewx":0,"skewy":-30,"rotatex":0,"rotatey":0,"maxh":60,"maxw":36},
        {"left":67,"top":21,"rotate":0,"h":60,"w":82,"skewx":0,"skewy":-30,"rotatex":0,"rotatey":0,"maxh":60,"maxw":36},
        {"left":62,"top":22,"rotate":0,"h":60,"w":82,"skewx":0,"skewy":-30,"rotatex":0,"rotatey":0,"maxh":60,"maxw":36},
        {"left":57,"top":24,"rotate":0,"h":60,"w":82,"skewx":0,"skewy":-30,"rotatex":0,"rotatey":0,"maxh":60,"maxw":36},
        {"left":51,"top":25,"rotate":0,"h":60,"w":82,"skewx":0,"skewy":-30,"rotatex":0,"rotatey":0,"maxh":60,"maxw":36},
        {"left":46,"top":26,"rotate":0,"h":60,"w":82,"skewx":0,"skewy":-30,"rotatex":0,"rotatey":0,"maxh":60,"maxw":36},
        {"left":40,"top":27,"rotate":0,"h":60,"w":82,"skewx":0,"skewy":-30,"rotatex":0,"rotatey":0,"maxh":60,"maxw":36},
        {"left":35,"top":28,"rotate":0,"h":60,"w":82,"skewx":0,"skewy":-30,"rotatex":0,"rotatey":0,"maxh":60,"maxw":36},
        {"left":30,"top":30,"rotate":0,"h":60,"w":82,"skewx":0,"skewy":-30,"rotatex":0,"rotatey":0,"maxh":60,"maxw":36}
        ]
    },
    {
        id:12,
        items:[
        {"left":72,"top":6,"rotate":0,"h":60,"w":68,"skewx":0,"skewy":-15,"rotatex":0,"rotatey":0,"maxh":60,"maxw":52},
        {"left":67,"top":8,"rotate":0,"h":60,"w":68,"skewx":0,"skewy":-15,"rotatex":0,"rotatey":0,"maxh":60,"maxw":52},
        {"left":63,"top":10,"rotate":0,"h":60,"w":68,"skewx":0,"skewy":-15,"rotatex":0,"rotatey":0,"maxh":60,"maxw":52},
        {"left":59,"top":13,"rotate":0,"h":60,"w":68,"skewx":0,"skewy":-15,"rotatex":0,"rotatey":0,"maxh":60,"maxw":52},
        {"left":55,"top":15,"rotate":0,"h":60,"w":68,"skewx":0,"skewy":-15,"rotatex":0,"rotatey":0,"maxh":60,"maxw":52},
        {"left":51,"top":18,"rotate":0,"h":60,"w":68,"skewx":0,"skewy":-15,"rotatex":0,"rotatey":0,"maxh":60,"maxw":52},
        {"left":46,"top":20,"rotate":0,"h":60,"w":68,"skewx":0,"skewy":-15,"rotatex":0,"rotatey":0,"maxh":60,"maxw":52},
        {"left":42,"top":22,"rotate":0,"h":60,"w":68,"skewx":0,"skewy":-15,"rotatex":0,"rotatey":0,"maxh":60,"maxw":52},
        {"left":38,"top":25,"rotate":0,"h":60,"w":68,"skewx":0,"skewy":-15,"rotatex":0,"rotatey":0,"maxh":60,"maxw":52},
        {"left":34,"top":27,"rotate":0,"h":60,"w":68,"skewx":0,"skewy":-15,"rotatex":0,"rotatey":0,"maxh":60,"maxw":52},
        {"left":30,"top":30,"rotate":0,"h":60,"w":68,"skewx":0,"skewy":-15,"rotatex":0,"rotatey":0,"maxh":60,"maxw":52}
        ]
    },
    {
        id:13,
        items:[
        {"left":0,"top":0,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":0,"rotatey":0,"maxh":60,"maxw":60},
        {"left":3,"top":3,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":0,"rotatey":0,"maxh":60,"maxw":60},
        {"left":6,"top":6,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":0,"rotatey":0,"maxh":60,"maxw":60},
        {"left":9,"top":9,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":0,"rotatey":0,"maxh":60,"maxw":60},
        {"left":12,"top":12,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":0,"rotatey":0,"maxh":60,"maxw":60},
        {"left":15,"top":15,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":0,"rotatey":0,"maxh":60,"maxw":60},
        {"left":18,"top":18,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":0,"rotatey":0,"maxh":60,"maxw":60},
        {"left":21,"top":21,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":0,"rotatey":0,"maxh":60,"maxw":60},
        {"left":24,"top":24,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":0,"rotatey":0,"maxh":60,"maxw":60},
        {"left":27,"top":27,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":0,"rotatey":0,"maxh":60,"maxw":60},
        {"left":30,"top":30,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":0,"rotatey":0,"maxh":60,"maxw":60}
        ]
    },
    {
        id:14,
        items:[
        {"left":-13,"top":69,"rotate":0,"h":68,"w":59,"skewx":-15,"skewy":0,"rotatex":0,"rotatey":0,"maxh":50,"maxw":60},
        {"left":-11,"top":65,"rotate":0,"h":68,"w":59,"skewx":-15,"skewy":0,"rotatex":0,"rotatey":0,"maxh":50,"maxw":60},
        {"left":-8,"top":62,"rotate":0,"h":68,"w":59,"skewx":-15,"skewy":0,"rotatex":0,"rotatey":0,"maxh":50,"maxw":60},
        {"left":-5,"top":59,"rotate":0,"h":68,"w":59,"skewx":-15,"skewy":0,"rotatex":0,"rotatey":0,"maxh":50,"maxw":60},
        {"left":-2,"top":56,"rotate":0,"h":68,"w":59,"skewx":-15,"skewy":0,"rotatex":0,"rotatey":0,"maxh":50,"maxw":60},
        {"left":1,"top":53,"rotate":0,"h":68,"w":59,"skewx":-15,"skewy":0,"rotatex":0,"rotatey":0,"maxh":50,"maxw":60},
        {"left":4,"top":50,"rotate":0,"h":68,"w":59,"skewx":-15,"skewy":0,"rotatex":0,"rotatey":0,"maxh":50,"maxw":60},
        {"left":7,"top":47,"rotate":0,"h":68,"w":59,"skewx":-15,"skewy":0,"rotatex":0,"rotatey":0,"maxh":50,"maxw":60},
        {"left":10,"top":44,"rotate":0,"h":68,"w":59,"skewx":-15,"skewy":0,"rotatex":0,"rotatey":0,"maxh":50,"maxw":60},
        {"left":13,"top":41,"rotate":0,"h":68,"w":59,"skewx":-15,"skewy":0,"rotatex":0,"rotatey":0,"maxh":50,"maxw":60},
        {"left":16,"top":38,"rotate":0,"h":68,"w":59,"skewx":-15,"skewy":0,"rotatex":0,"rotatey":0,"maxh":50,"maxw":60}
        ]
    },
    {
        id:15,
        items:[
        {"left":-6,"top":94,"rotate":0,"h":78,"w":60,"skewx":-30,"skewy":0,"rotatex":0,"rotatey":0,"maxh":40,"maxw":60},
        {"left":-5,"top":89,"rotate":0,"h":78,"w":60,"skewx":-30,"skewy":0,"rotatex":0,"rotatey":0,"maxh":40,"maxw":60},
        {"left":-4,"top":84,"rotate":0,"h":78,"w":60,"skewx":-30,"skewy":0,"rotatex":0,"rotatey":0,"maxh":40,"maxw":60},
        {"left":-3,"top":80,"rotate":0,"h":78,"w":60,"skewx":-30,"skewy":0,"rotatex":0,"rotatey":0,"maxh":40,"maxw":60},
        {"left":-2,"top":75,"rotate":0,"h":78,"w":60,"skewx":-30,"skewy":0,"rotatex":0,"rotatey":0,"maxh":40,"maxw":60},
        {"left":-1,"top":71,"rotate":0,"h":78,"w":60,"skewx":-30,"skewy":0,"rotatex":0,"rotatey":0,"maxh":40,"maxw":60},
        {"left":0,"top":66,"rotate":0,"h":78,"w":60,"skewx":-30,"skewy":0,"rotatex":0,"rotatey":0,"maxh":40,"maxw":60},
        {"left":1,"top":61,"rotate":0,"h":78,"w":60,"skewx":-30,"skewy":0,"rotatex":0,"rotatey":0,"maxh":40,"maxw":60},
        {"left":2,"top":57,"rotate":0,"h":78,"w":60,"skewx":-30,"skewy":0,"rotatex":0,"rotatey":0,"maxh":40,"maxw":60},
        {"left":3,"top":52,"rotate":0,"h":78,"w":60,"skewx":-30,"skewy":0,"rotatex":0,"rotatey":0,"maxh":40,"maxw":60},
        {"left":4,"top":48,"rotate":0,"h":78,"w":60,"skewx":-30,"skewy":0,"rotatex":0,"rotatey":0,"maxh":40,"maxw":60}
        ]
    },
    {
        id:16,
        items:[
        {"left":0,"top":120,"rotate":0,"h":90,"w":60,"skewx":-45,"skewy":0,"rotatex":0,"rotatey":0,"maxh":28,"maxw":60},
        {"left":0,"top":114,"rotate":0,"h":90,"w":60,"skewx":-45,"skewy":0,"rotatex":0,"rotatey":0,"maxh":28,"maxw":60},
        {"left":0,"top":108,"rotate":0,"h":90,"w":60,"skewx":-45,"skewy":0,"rotatex":0,"rotatey":0,"maxh":28,"maxw":60},
        {"left":0,"top":102,"rotate":0,"h":90,"w":60,"skewx":-45,"skewy":0,"rotatex":0,"rotatey":0,"maxh":28,"maxw":60},
        {"left":0,"top":96,"rotate":0,"h":90,"w":60,"skewx":-45,"skewy":0,"rotatex":0,"rotatey":0,"maxh":28,"maxw":60},
        {"left":0,"top":90,"rotate":0,"h":90,"w":60,"skewx":-45,"skewy":0,"rotatex":0,"rotatey":0,"maxh":28,"maxw":60},
        {"left":0,"top":84,"rotate":0,"h":90,"w":60,"skewx":-45,"skewy":0,"rotatex":0,"rotatey":0,"maxh":28,"maxw":60},
        {"left":0,"top":78,"rotate":0,"h":90,"w":60,"skewx":-45,"skewy":0,"rotatex":0,"rotatey":0,"maxh":28,"maxw":60},
        {"left":0,"top":72,"rotate":0,"h":90,"w":60,"skewx":-45,"skewy":0,"rotatex":0,"rotatey":0,"maxh":28,"maxw":60},
        {"left":0,"top":66,"rotate":0,"h":90,"w":60,"skewx":-45,"skewy":0,"rotatex":0,"rotatey":0,"maxh":28,"maxw":60},
        {"left":0,"top":60,"rotate":0,"h":90,"w":60,"skewx":-45,"skewy":0,"rotatex":0,"rotatey":0,"maxh":28,"maxw":60}
        ]
    },
    {
        id:17,
        items:[
        {"left":22,"top":184,"rotate":0,"h":80,"w":60,"skewx":30,"skewy":0,"rotatex":-180,"rotatey":0,"maxh":40,"maxw":60},
        {"left":20,"top":178,"rotate":0,"h":80,"w":60,"skewx":30,"skewy":0,"rotatex":-180,"rotatey":0,"maxh":40,"maxw":60},
        {"left":18,"top":173,"rotate":0,"h":80,"w":60,"skewx":30,"skewy":0,"rotatex":-180,"rotatey":0,"maxh":40,"maxw":60},
        {"left":17,"top":168,"rotate":0,"h":80,"w":60,"skewx":30,"skewy":0,"rotatex":-180,"rotatey":0,"maxh":40,"maxw":60},
        {"left":15,"top":163,"rotate":0,"h":80,"w":60,"skewx":30,"skewy":0,"rotatex":-180,"rotatey":0,"maxh":40,"maxw":60},
        {"left":14,"top":158,"rotate":0,"h":80,"w":60,"skewx":30,"skewy":0,"rotatex":-180,"rotatey":0,"maxh":40,"maxw":60},
        {"left":12,"top":152,"rotate":0,"h":80,"w":60,"skewx":30,"skewy":0,"rotatex":-180,"rotatey":0,"maxh":40,"maxw":60},
        {"left":10,"top":147,"rotate":0,"h":80,"w":60,"skewx":30,"skewy":0,"rotatex":-180,"rotatey":0,"maxh":40,"maxw":60},
        {"left":9,"top":142,"rotate":0,"h":80,"w":60,"skewx":30,"skewy":0,"rotatex":-180,"rotatey":0,"maxh":40,"maxw":60},
        {"left":7,"top":137,"rotate":0,"h":80,"w":60,"skewx":30,"skewy":0,"rotatex":-180,"rotatey":0,"maxh":40,"maxw":60},
        {"left":6,"top":132,"rotate":0,"h":78,"w":60,"skewx":30,"skewy":0,"rotatex":-180,"rotatey":0,"maxh":40,"maxw":60}
        ]
    },
    {
        id:18,
        items:[
        {"left":42,"top":186,"rotate":0,"h":66,"w":60,"skewx":15,"skewy":0,"rotatex":-180,"rotatey":0,"maxh":50,"maxw":60},
        {"left":39,"top":181,"rotate":0,"h":66,"w":60,"skewx":15,"skewy":0,"rotatex":-180,"rotatey":0,"maxh":50,"maxw":60},
        {"left":36,"top":177,"rotate":0,"h":66,"w":60,"skewx":15,"skewy":0,"rotatex":-180,"rotatey":0,"maxh":50,"maxw":60},
        {"left":34,"top":173,"rotate":0,"h":66,"w":60,"skewx":15,"skewy":0,"rotatex":-180,"rotatey":0,"maxh":50,"maxw":60},
        {"left":31,"top":169,"rotate":0,"h":66,"w":60,"skewx":15,"skewy":0,"rotatex":-180,"rotatey":0,"maxh":50,"maxw":60},
        {"left":29,"top":165,"rotate":0,"h":66,"w":60,"skewx":15,"skewy":0,"rotatex":-180,"rotatey":0,"maxh":50,"maxw":60},
        {"left":26,"top":160,"rotate":0,"h":66,"w":60,"skewx":15,"skewy":0,"rotatex":-180,"rotatey":0,"maxh":50,"maxw":60},
        {"left":23,"top":156,"rotate":0,"h":66,"w":60,"skewx":15,"skewy":0,"rotatex":-180,"rotatey":0,"maxh":50,"maxw":60},
        {"left":21,"top":152,"rotate":0,"h":66,"w":60,"skewx":15,"skewy":0,"rotatex":-180,"rotatey":0,"maxh":50,"maxw":60},
        {"left":18,"top":148,"rotate":0,"h":66,"w":60,"skewx":15,"skewy":0,"rotatex":-180,"rotatey":0,"maxh":50,"maxw":60},
        {"left":16,"top":144,"rotate":0,"h":66,"w":60,"skewx":15,"skewy":0,"rotatex":-180,"rotatey":0,"maxh":50,"maxw":60}
        ]
    },
    {
        id:19,
        items:[
        {"left":60,"top":180,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":-180,"rotatey":0,"maxh":60,"maxw":60},
        {"left":57,"top":177,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":-180,"rotatey":0,"maxh":60,"maxw":60},
        {"left":54,"top":174,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":-180,"rotatey":0,"maxh":60,"maxw":60},
        {"left":51,"top":171,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":-180,"rotatey":0,"maxh":60,"maxw":60},
        {"left":48,"top":168,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":-180,"rotatey":0,"maxh":60,"maxw":60},
        {"left":45,"top":165,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":-180,"rotatey":0,"maxh":60,"maxw":60},
        {"left":42,"top":162,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":-180,"rotatey":0,"maxh":60,"maxw":60},
        {"left":39,"top":159,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":-180,"rotatey":0,"maxh":60,"maxw":60},
        {"left":36,"top":156,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":-180,"rotatey":0,"maxh":60,"maxw":60},
        {"left":33,"top":153,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":-180,"rotatey":0,"maxh":60,"maxw":60},
        {"left":30,"top":150,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":-180,"rotatey":0,"maxh":60,"maxw":60}
        ]
    },
    {
        id:20,
        items:[
        {"left":56,"top":48,"rotate":0,"h":66,"w":60,"skewx":-15,"skewy":0,"rotatex":0,"rotatey":0,"maxh":50,"maxw":60},
        {"left":53,"top":52,"rotate":0,"h":66,"w":60,"skewx":-15,"skewy":0,"rotatex":0,"rotatey":0,"maxh":50,"maxw":60},
        {"left":50,"top":56,"rotate":0,"h":66,"w":60,"skewx":-15,"skewy":0,"rotatex":0,"rotatey":0,"maxh":50,"maxw":60},
        {"left":48,"top":60,"rotate":0,"h":66,"w":60,"skewx":-15,"skewy":0,"rotatex":0,"rotatey":0,"maxh":50,"maxw":60},
        {"left":45,"top":64,"rotate":0,"h":66,"w":60,"skewx":-15,"skewy":0,"rotatex":0,"rotatey":0,"maxh":50,"maxw":60},
        {"left":43,"top":69,"rotate":0,"h":66,"w":60,"skewx":-15,"skewy":0,"rotatex":0,"rotatey":0,"maxh":50,"maxw":60},
        {"left":40,"top":73,"rotate":0,"h":66,"w":60,"skewx":-15,"skewy":0,"rotatex":0,"rotatey":0,"maxh":50,"maxw":60},
        {"left":37,"top":77,"rotate":0,"h":66,"w":60,"skewx":-15,"skewy":0,"rotatex":0,"rotatey":0,"maxh":50,"maxw":60},
        {"left":35,"top":81,"rotate":0,"h":66,"w":60,"skewx":-15,"skewy":0,"rotatex":0,"rotatey":0,"maxh":50,"maxw":60},
        {"left":32,"top":85,"rotate":0,"h":66,"w":60,"skewx":-15,"skewy":0,"rotatex":0,"rotatey":0,"maxh":50,"maxw":60},
        {"left":30,"top":90,"rotate":0,"h":66,"w":60,"skewx":-15,"skewy":0,"rotatex":0,"rotatey":0,"maxh":50,"maxw":60}
        ]
    },
    {
        id:21,
        items:[
        {"left":46,"top":38,"rotate":0,"h":78,"w":60,"skewx":-30,"skewy":0,"rotatex":0,"rotatey":0,"maxh":40,"maxw":60},
        {"left":44,"top":43,"rotate":0,"h":78,"w":60,"skewx":-30,"skewy":0,"rotatex":0,"rotatey":0,"maxh":40,"maxw":60},
        {"left":42,"top":48,"rotate":0,"h":78,"w":60,"skewx":-30,"skewy":0,"rotatex":0,"rotatey":0,"maxh":40,"maxw":60},
        {"left":41,"top":53,"rotate":0,"h":78,"w":60,"skewx":-30,"skewy":0,"rotatex":0,"rotatey":0,"maxh":40,"maxw":60},
        {"left":39,"top":58,"rotate":0,"h":78,"w":60,"skewx":-30,"skewy":0,"rotatex":0,"rotatey":0,"maxh":40,"maxw":60},
        {"left":38,"top":64,"rotate":0,"h":78,"w":60,"skewx":-30,"skewy":0,"rotatex":0,"rotatey":0,"maxh":40,"maxw":60},
        {"left":36,"top":69,"rotate":0,"h":78,"w":60,"skewx":-30,"skewy":0,"rotatex":0,"rotatey":0,"maxh":40,"maxw":60},
        {"left":34,"top":74,"rotate":0,"h":78,"w":60,"skewx":-30,"skewy":0,"rotatex":0,"rotatey":0,"maxh":40,"maxw":60},
        {"left":33,"top":79,"rotate":0,"h":78,"w":60,"skewx":-30,"skewy":0,"rotatex":0,"rotatey":0,"maxh":40,"maxw":60},
        {"left":31,"top":84,"rotate":0,"h":78,"w":60,"skewx":-30,"skewy":0,"rotatex":0,"rotatey":0,"maxh":40,"maxw":60},
        {"left":30,"top":90,"rotate":0,"h":78,"w":60,"skewx":-30,"skewy":0,"rotatex":0,"rotatey":0,"maxh":40,"maxw":60}
        ]
    },
    {
        id:22,
        items:[
        {"left":60,"top":60,"rotate":0,"h":90,"w":58,"skewx":-45,"skewy":0,"rotatex":-180,"rotatey":0,"maxh":28,"maxw":60},
        {"left":60,"top":66,"rotate":0,"h":90,"w":58,"skewx":-45,"skewy":0,"rotatex":-180,"rotatey":0,"maxh":28,"maxw":60},
        {"left":60,"top":72,"rotate":0,"h":90,"w":58,"skewx":-45,"skewy":0,"rotatex":-180,"rotatey":0,"maxh":28,"maxw":60},
        {"left":60,"top":78,"rotate":0,"h":90,"w":58,"skewx":-45,"skewy":0,"rotatex":-180,"rotatey":0,"maxh":28,"maxw":60},
        {"left":60,"top":84,"rotate":0,"h":90,"w":58,"skewx":-45,"skewy":0,"rotatex":-180,"rotatey":0,"maxh":28,"maxw":60},
        {"left":60,"top":90,"rotate":0,"h":90,"w":58,"skewx":-45,"skewy":0,"rotatex":-180,"rotatey":0,"maxh":28,"maxw":60},
        {"left":60,"top":96,"rotate":0,"h":90,"w":58,"skewx":-45,"skewy":0,"rotatex":-180,"rotatey":0,"maxh":28,"maxw":60},
        {"left":60,"top":102,"rotate":0,"h":90,"w":58,"skewx":-45,"skewy":0,"rotatex":-180,"rotatey":0,"maxh":28,"maxw":60},
        {"left":60,"top":108,"rotate":0,"h":90,"w":58,"skewx":-45,"skewy":0,"rotatex":-180,"rotatey":0,"maxh":28,"maxw":60},
        {"left":60,"top":114,"rotate":0,"h":90,"w":58,"skewx":-45,"skewy":0,"rotatex":-180,"rotatey":0,"maxh":28,"maxw":60},
        {"left":60,"top":120,"rotate":0,"h":90,"w":58,"skewx":-45,"skewy":0,"rotatex":-180,"rotatey":0,"maxh":28,"maxw":60}
        ]
    },
    {
        id:23,
        items:[
        {"left":40,"top":-4,"rotate":0,"h":78,"w":60,"skewx":30,"skewy":0,"rotatex":0,"rotatey":0,"maxh":40,"maxw":60},
        {"left":41,"top":1,"rotate":0,"h":78,"w":60,"skewx":30,"skewy":0,"rotatex":0,"rotatey":0,"maxh":40,"maxw":60},
        {"left":42,"top":6,"rotate":0,"h":78,"w":60,"skewx":30,"skewy":0,"rotatex":0,"rotatey":0,"maxh":40,"maxw":60},
        {"left":44,"top":11,"rotate":0,"h":78,"w":60,"skewx":30,"skewy":0,"rotatex":0,"rotatey":0,"maxh":40,"maxw":60},
        {"left":45,"top":16,"rotate":0,"h":78,"w":60,"skewx":30,"skewy":0,"rotatex":0,"rotatey":0,"maxh":40,"maxw":60},
        {"left":47,"top":22,"rotate":0,"h":78,"w":60,"skewx":30,"skewy":0,"rotatex":0,"rotatey":0,"maxh":40,"maxw":60},
        {"left":48,"top":27,"rotate":0,"h":78,"w":60,"skewx":30,"skewy":0,"rotatex":0,"rotatey":0,"maxh":40,"maxw":60},
        {"left":49,"top":32,"rotate":0,"h":78,"w":60,"skewx":30,"skewy":0,"rotatex":0,"rotatey":0,"maxh":40,"maxw":60},
        {"left":51,"top":37,"rotate":0,"h":78,"w":60,"skewx":30,"skewy":0,"rotatex":0,"rotatey":0,"maxh":40,"maxw":60},
        {"left":52,"top":42,"rotate":0,"h":78,"w":60,"skewx":30,"skewy":0,"rotatex":0,"rotatey":0,"maxh":40,"maxw":60},
        {"left":54,"top":48,"rotate":0,"h":78,"w":60,"skewx":30,"skewy":0,"rotatex":0,"rotatey":0,"maxh":40,"maxw":60}
        ]
    },
    {
        id:24,
        items:[
        {"left":20,"top":-6,"rotate":0,"h":66,"w":60,"skewx":15,"skewy":0,"rotatex":0,"rotatey":0,"maxh":50,"maxw":60},
        {"left":22,"top":-2,"rotate":0,"h":66,"w":60,"skewx":15,"skewy":0,"rotatex":0,"rotatey":0,"maxh":50,"maxw":60},
        {"left":24,"top":2,"rotate":0,"h":66,"w":60,"skewx":15,"skewy":0,"rotatex":0,"rotatey":0,"maxh":50,"maxw":60},
        {"left":27,"top":6,"rotate":0,"h":66,"w":60,"skewx":15,"skewy":0,"rotatex":0,"rotatey":0,"maxh":50,"maxw":60},
        {"left":29,"top":10,"rotate":0,"h":66,"w":60,"skewx":15,"skewy":0,"rotatex":0,"rotatey":0,"maxh":50,"maxw":60},
        {"left":32,"top":15,"rotate":0,"h":66,"w":60,"skewx":15,"skewy":0,"rotatex":0,"rotatey":0,"maxh":50,"maxw":60},
        {"left":34,"top":19,"rotate":0,"h":66,"w":60,"skewx":15,"skewy":0,"rotatex":0,"rotatey":0,"maxh":50,"maxw":60},
        {"left":36,"top":23,"rotate":0,"h":66,"w":60,"skewx":15,"skewy":0,"rotatex":0,"rotatey":0,"maxh":50,"maxw":60},
        {"left":39,"top":27,"rotate":0,"h":66,"w":60,"skewx":15,"skewy":0,"rotatex":0,"rotatey":0,"maxh":50,"maxw":60},
        {"left":41,"top":31,"rotate":0,"h":66,"w":60,"skewx":15,"skewy":0,"rotatex":0,"rotatey":0,"maxh":50,"maxw":60},
        {"left":44,"top":36,"rotate":0,"h":66,"w":60,"skewx":15,"skewy":0,"rotatex":0,"rotatey":0,"maxh":50,"maxw":60}
        ]
    },
    {
        id:25,
        items:[
        {"left":0,"top":0,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":0,"rotatey":0,"maxh":60,"maxw":60},
        {"left":3,"top":3,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":0,"rotatey":0,"maxh":60,"maxw":60},
        {"left":6,"top":6,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":0,"rotatey":0,"maxh":60,"maxw":60},
        {"left":9,"top":9,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":0,"rotatey":0,"maxh":60,"maxw":60},
        {"left":12,"top":12,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":0,"rotatey":0,"maxh":60,"maxw":60},
        {"left":15,"top":15,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":0,"rotatey":0,"maxh":60,"maxw":60},
        {"left":18,"top":18,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":0,"rotatey":0,"maxh":60,"maxw":60},
        {"left":21,"top":21,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":0,"rotatey":0,"maxh":60,"maxw":60},
        {"left":24,"top":24,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":0,"rotatey":0,"maxh":60,"maxw":60},
        {"left":27,"top":27,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":0,"rotatey":0,"maxh":60,"maxw":60},
        {"left":30,"top":30,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":0,"rotatey":0,"maxh":60,"maxw":60}
        ]
    },
    {
        id:26,
        items:[
        {"left":10,"top":4,"rotate":0,"h":68,"w":68,"skewx":15,"skewy":15,"rotatex":0,"rotatey":-15,"maxh":50,"maxw":50},
        {"left":13,"top":7,"rotate":0,"h":68,"w":68,"skewx":15,"skewy":15,"rotatex":0,"rotatey":-15,"maxh":50,"maxw":50},
        {"left":17,"top":10,"rotate":0,"h":68,"w":68,"skewx":15,"skewy":15,"rotatex":0,"rotatey":-15,"maxh":50,"maxw":50},
        {"left":20,"top":14,"rotate":0,"h":68,"w":68,"skewx":15,"skewy":15,"rotatex":0,"rotatey":-15,"maxh":50,"maxw":50},
        {"left":24,"top":17,"rotate":0,"h":68,"w":68,"skewx":15,"skewy":15,"rotatex":0,"rotatey":-15,"maxh":50,"maxw":50},
        {"left":28,"top":21,"rotate":0,"h":68,"w":68,"skewx":15,"skewy":15,"rotatex":0,"rotatey":-15,"maxh":50,"maxw":50},
        {"left":31,"top":24,"rotate":0,"h":68,"w":68,"skewx":15,"skewy":15,"rotatex":0,"rotatey":-15,"maxh":50,"maxw":50},
        {"left":35,"top":27,"rotate":0,"h":68,"w":68,"skewx":15,"skewy":15,"rotatex":0,"rotatey":-15,"maxh":50,"maxw":50},
        {"left":38,"top":31,"rotate":0,"h":68,"w":68,"skewx":15,"skewy":15,"rotatex":0,"rotatey":-15,"maxh":50,"maxw":50},
        {"left":42,"top":34,"rotate":0,"h":68,"w":68,"skewx":15,"skewy":15,"rotatex":0,"rotatey":-15,"maxh":50,"maxw":50},
        {"left":46,"top":38,"rotate":0,"h":68,"w":68,"skewx":15,"skewy":15,"rotatex":0,"rotatey":-15,"maxh":50,"maxw":50}
        ]
    },
    {
        id:27,
        items:[
        {"left":18,"top":8,"rotate":0,"h":78,"w":78,"skewx":30,"skewy":40,"rotatex":0,"rotatey":-45,"maxh":40,"maxw":40},
        {"left":21,"top":11,"rotate":0,"h":78,"w":78,"skewx":30,"skewy":40,"rotatex":0,"rotatey":-45,"maxh":40,"maxw":40},
        {"left":25,"top":15,"rotate":0,"h":78,"w":78,"skewx":30,"skewy":40,"rotatex":0,"rotatey":-45,"maxh":40,"maxw":40},
        {"left":29,"top":19,"rotate":0,"h":78,"w":78,"skewx":30,"skewy":40,"rotatex":0,"rotatey":-45,"maxh":40,"maxw":40},
        {"left":33,"top":23,"rotate":0,"h":78,"w":78,"skewx":30,"skewy":40,"rotatex":0,"rotatey":-45,"maxh":40,"maxw":40},
        {"left":37,"top":27,"rotate":0,"h":78,"w":78,"skewx":30,"skewy":40,"rotatex":0,"rotatey":-45,"maxh":40,"maxw":40},
        {"left":40,"top":30,"rotate":0,"h":78,"w":78,"skewx":30,"skewy":40,"rotatex":0,"rotatey":-45,"maxh":40,"maxw":40},
        {"left":44,"top":34,"rotate":0,"h":78,"w":78,"skewx":30,"skewy":40,"rotatex":0,"rotatey":-45,"maxh":40,"maxw":40},
        {"left":48,"top":38,"rotate":0,"h":78,"w":78,"skewx":30,"skewy":40,"rotatex":0,"rotatey":-45,"maxh":40,"maxw":40},
        {"left":52,"top":42,"rotate":0,"h":78,"w":78,"skewx":30,"skewy":40,"rotatex":0,"rotatey":-45,"maxh":40,"maxw":40},
        {"left":56,"top":46,"rotate":0,"h":78,"w":78,"skewx":30,"skewy":40,"rotatex":0,"rotatey":-45,"maxh":40,"maxw":40}
        ]
    },
    {
        id:28,
        items:[
        {"left":32,"top":28,"rotate":0,"h":78,"w":78,"skewx":30,"skewy":40,"rotatex":0,"rotatey":-45,"maxh":40,"maxw":40},
        {"left":35,"top":31,"rotate":0,"h":78,"w":78,"skewx":30,"skewy":40,"rotatex":0,"rotatey":-45,"maxh":40,"maxw":40},
        {"left":39,"top":35,"rotate":0,"h":78,"w":78,"skewx":30,"skewy":40,"rotatex":0,"rotatey":-45,"maxh":40,"maxw":40},
        {"left":43,"top":39,"rotate":0,"h":78,"w":78,"skewx":30,"skewy":40,"rotatex":0,"rotatey":-45,"maxh":40,"maxw":40},
        {"left":47,"top":43,"rotate":0,"h":78,"w":78,"skewx":30,"skewy":40,"rotatex":0,"rotatey":-45,"maxh":40,"maxw":40},
        {"left":51,"top":47,"rotate":0,"h":78,"w":78,"skewx":30,"skewy":40,"rotatex":0,"rotatey":-45,"maxh":40,"maxw":40},
        {"left":54,"top":50,"rotate":0,"h":78,"w":78,"skewx":30,"skewy":40,"rotatex":0,"rotatey":-45,"maxh":40,"maxw":40},
        {"left":58,"top":54,"rotate":0,"h":78,"w":78,"skewx":30,"skewy":40,"rotatex":0,"rotatey":-45,"maxh":40,"maxw":40},
        {"left":62,"top":58,"rotate":0,"h":78,"w":78,"skewx":30,"skewy":40,"rotatex":0,"rotatey":-45,"maxh":40,"maxw":40},
        {"left":66,"top":62,"rotate":0,"h":78,"w":78,"skewx":30,"skewy":40,"rotatex":0,"rotatey":-45,"maxh":40,"maxw":40},
        {"left":70,"top":66,"rotate":0,"h":78,"w":78,"skewx":30,"skewy":40,"rotatex":0,"rotatey":-45,"maxh":40,"maxw":40}
        ]
    },
    {
        id:29,
        items:[
        {"left":50,"top":44,"rotate":0,"h":68,"w":68,"skewx":15,"skewy":15,"rotatex":0,"rotatey":-15,"maxh":50,"maxw":50},
        {"left":53,"top":47,"rotate":0,"h":68,"w":68,"skewx":15,"skewy":15,"rotatex":0,"rotatey":-15,"maxh":50,"maxw":50},
        {"left":57,"top":50,"rotate":0,"h":68,"w":68,"skewx":15,"skewy":15,"rotatex":0,"rotatey":-15,"maxh":50,"maxw":50},
        {"left":60,"top":54,"rotate":0,"h":68,"w":68,"skewx":15,"skewy":15,"rotatex":0,"rotatey":-15,"maxh":50,"maxw":50},
        {"left":64,"top":57,"rotate":0,"h":68,"w":68,"skewx":15,"skewy":15,"rotatex":0,"rotatey":-15,"maxh":50,"maxw":50},
        {"left":68,"top":61,"rotate":0,"h":68,"w":68,"skewx":15,"skewy":15,"rotatex":0,"rotatey":-15,"maxh":50,"maxw":50},
        {"left":71,"top":64,"rotate":0,"h":68,"w":68,"skewx":15,"skewy":15,"rotatex":0,"rotatey":-15,"maxh":50,"maxw":50},
        {"left":75,"top":67,"rotate":0,"h":68,"w":68,"skewx":15,"skewy":15,"rotatex":0,"rotatey":-15,"maxh":50,"maxw":50},
        {"left":78,"top":71,"rotate":0,"h":68,"w":68,"skewx":15,"skewy":15,"rotatex":0,"rotatey":-15,"maxh":50,"maxw":50},
        {"left":82,"top":74,"rotate":0,"h":68,"w":68,"skewx":15,"skewy":15,"rotatex":0,"rotatey":-15,"maxh":50,"maxw":50},
        {"left":86,"top":78,"rotate":0,"h":68,"w":68,"skewx":15,"skewy":15,"rotatex":0,"rotatey":-15,"maxh":50,"maxw":50}
        ]
    },
    {
        id:30,
        items:[
        {"left":60,"top":60,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":0,"rotatey":0,"maxh":60,"maxw":60},
        {"left":63,"top":63,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":0,"rotatey":0,"maxh":60,"maxw":60},
        {"left":66,"top":66,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":0,"rotatey":0,"maxh":60,"maxw":60},
        {"left":69,"top":69,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":0,"rotatey":0,"maxh":60,"maxw":60},
        {"left":72,"top":72,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":0,"rotatey":0,"maxh":60,"maxw":60},
        {"left":75,"top":75,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":0,"rotatey":0,"maxh":60,"maxw":60},
        {"left":78,"top":78,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":0,"rotatey":0,"maxh":60,"maxw":60},
        {"left":81,"top":81,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":0,"rotatey":0,"maxh":60,"maxw":60},
        {"left":84,"top":84,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":0,"rotatey":0,"maxh":60,"maxw":60},
        {"left":87,"top":87,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":0,"rotatey":0,"maxh":60,"maxw":60},
        {"left":90,"top":90,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":0,"rotatey":0,"maxh":60,"maxw":60}
        ]
    },
    {
        id:31,
        items:[
        {"left":50,"top":44,"rotate":0,"h":68,"w":68,"skewx":15,"skewy":15,"rotatex":0,"rotatey":-15,"maxh":50,"maxw":50},
        {"left":53,"top":47,"rotate":0,"h":68,"w":68,"skewx":15,"skewy":15,"rotatex":0,"rotatey":-15,"maxh":50,"maxw":50},
        {"left":57,"top":50,"rotate":0,"h":68,"w":68,"skewx":15,"skewy":15,"rotatex":0,"rotatey":-15,"maxh":50,"maxw":50},
        {"left":60,"top":54,"rotate":0,"h":68,"w":68,"skewx":15,"skewy":15,"rotatex":0,"rotatey":-15,"maxh":50,"maxw":50},
        {"left":64,"top":57,"rotate":0,"h":68,"w":68,"skewx":15,"skewy":15,"rotatex":0,"rotatey":-15,"maxh":50,"maxw":50},
        {"left":68,"top":61,"rotate":0,"h":68,"w":68,"skewx":15,"skewy":15,"rotatex":0,"rotatey":-15,"maxh":50,"maxw":50},
        {"left":71,"top":64,"rotate":0,"h":68,"w":68,"skewx":15,"skewy":15,"rotatex":0,"rotatey":-15,"maxh":50,"maxw":50},
        {"left":75,"top":67,"rotate":0,"h":68,"w":68,"skewx":15,"skewy":15,"rotatex":0,"rotatey":-15,"maxh":50,"maxw":50},
        {"left":78,"top":71,"rotate":0,"h":68,"w":68,"skewx":15,"skewy":15,"rotatex":0,"rotatey":-15,"maxh":50,"maxw":50},
        {"left":82,"top":74,"rotate":0,"h":68,"w":68,"skewx":15,"skewy":15,"rotatex":0,"rotatey":-15,"maxh":50,"maxw":50},
        {"left":86,"top":78,"rotate":0,"h":68,"w":68,"skewx":15,"skewy":15,"rotatex":0,"rotatey":-15,"maxh":50,"maxw":50}
        ]
    },
    {
        id:32,
        items:[
        {"left":32,"top":28,"rotate":0,"h":78,"w":78,"skewx":30,"skewy":40,"rotatex":0,"rotatey":-45,"maxh":40,"maxw":40},
        {"left":35,"top":31,"rotate":0,"h":78,"w":78,"skewx":30,"skewy":40,"rotatex":0,"rotatey":-45,"maxh":40,"maxw":40},
        {"left":39,"top":35,"rotate":0,"h":78,"w":78,"skewx":30,"skewy":40,"rotatex":0,"rotatey":-45,"maxh":40,"maxw":40},
        {"left":43,"top":39,"rotate":0,"h":78,"w":78,"skewx":30,"skewy":40,"rotatex":0,"rotatey":-45,"maxh":40,"maxw":40},
        {"left":47,"top":43,"rotate":0,"h":78,"w":78,"skewx":30,"skewy":40,"rotatex":0,"rotatey":-45,"maxh":40,"maxw":40},
        {"left":51,"top":47,"rotate":0,"h":78,"w":78,"skewx":30,"skewy":40,"rotatex":0,"rotatey":-45,"maxh":40,"maxw":40},
        {"left":54,"top":50,"rotate":0,"h":78,"w":78,"skewx":30,"skewy":40,"rotatex":0,"rotatey":-45,"maxh":40,"maxw":40},
        {"left":58,"top":54,"rotate":0,"h":78,"w":78,"skewx":30,"skewy":40,"rotatex":0,"rotatey":-45,"maxh":40,"maxw":40},
        {"left":62,"top":58,"rotate":0,"h":78,"w":78,"skewx":30,"skewy":40,"rotatex":0,"rotatey":-45,"maxh":40,"maxw":40},
        {"left":66,"top":62,"rotate":0,"h":78,"w":78,"skewx":30,"skewy":40,"rotatex":0,"rotatey":-45,"maxh":40,"maxw":40},
        {"left":70,"top":66,"rotate":0,"h":78,"w":78,"skewx":30,"skewy":40,"rotatex":0,"rotatey":-45,"maxh":40,"maxw":40}
        ]
    },
    {
        id:33,
        items:[
        {"left":18,"top":8,"rotate":0,"h":78,"w":78,"skewx":30,"skewy":40,"rotatex":0,"rotatey":-45,"maxh":40,"maxw":40},
        {"left":21,"top":11,"rotate":0,"h":78,"w":78,"skewx":30,"skewy":40,"rotatex":0,"rotatey":-45,"maxh":40,"maxw":40},
        {"left":25,"top":15,"rotate":0,"h":78,"w":78,"skewx":30,"skewy":40,"rotatex":0,"rotatey":-45,"maxh":40,"maxw":40},
        {"left":29,"top":19,"rotate":0,"h":78,"w":78,"skewx":30,"skewy":40,"rotatex":0,"rotatey":-45,"maxh":40,"maxw":40},
        {"left":33,"top":23,"rotate":0,"h":78,"w":78,"skewx":30,"skewy":40,"rotatex":0,"rotatey":-45,"maxh":40,"maxw":40},
        {"left":37,"top":27,"rotate":0,"h":78,"w":78,"skewx":30,"skewy":40,"rotatex":0,"rotatey":-45,"maxh":40,"maxw":40},
        {"left":40,"top":30,"rotate":0,"h":78,"w":78,"skewx":30,"skewy":40,"rotatex":0,"rotatey":-45,"maxh":40,"maxw":40},
        {"left":44,"top":34,"rotate":0,"h":78,"w":78,"skewx":30,"skewy":40,"rotatex":0,"rotatey":-45,"maxh":40,"maxw":40},
        {"left":48,"top":38,"rotate":0,"h":78,"w":78,"skewx":30,"skewy":40,"rotatex":0,"rotatey":-45,"maxh":40,"maxw":40},
        {"left":52,"top":42,"rotate":0,"h":78,"w":78,"skewx":30,"skewy":40,"rotatex":0,"rotatey":-45,"maxh":40,"maxw":40},
        {"left":56,"top":46,"rotate":0,"h":78,"w":78,"skewx":30,"skewy":40,"rotatex":0,"rotatey":-45,"maxh":40,"maxw":40}
        ]
    },
    {
        id:34,
        items:[
        {"left":10,"top":4,"rotate":0,"h":68,"w":68,"skewx":15,"skewy":15,"rotatex":0,"rotatey":-15,"maxh":50,"maxw":50},
        {"left":13,"top":7,"rotate":0,"h":68,"w":68,"skewx":15,"skewy":15,"rotatex":0,"rotatey":-15,"maxh":50,"maxw":50},
        {"left":17,"top":10,"rotate":0,"h":68,"w":68,"skewx":15,"skewy":15,"rotatex":0,"rotatey":-15,"maxh":50,"maxw":50},
        {"left":20,"top":14,"rotate":0,"h":68,"w":68,"skewx":15,"skewy":15,"rotatex":0,"rotatey":-15,"maxh":50,"maxw":50},
        {"left":24,"top":17,"rotate":0,"h":68,"w":68,"skewx":15,"skewy":15,"rotatex":0,"rotatey":-15,"maxh":50,"maxw":50},
        {"left":28,"top":21,"rotate":0,"h":68,"w":68,"skewx":15,"skewy":15,"rotatex":0,"rotatey":-15,"maxh":50,"maxw":50},
        {"left":31,"top":24,"rotate":0,"h":68,"w":68,"skewx":15,"skewy":15,"rotatex":0,"rotatey":-15,"maxh":50,"maxw":50},
        {"left":35,"top":27,"rotate":0,"h":68,"w":68,"skewx":15,"skewy":15,"rotatex":0,"rotatey":-15,"maxh":50,"maxw":50},
        {"left":38,"top":31,"rotate":0,"h":68,"w":68,"skewx":15,"skewy":15,"rotatex":0,"rotatey":-15,"maxh":50,"maxw":50},
        {"left":42,"top":34,"rotate":0,"h":68,"w":68,"skewx":15,"skewy":15,"rotatex":0,"rotatey":-15,"maxh":50,"maxw":50},
        {"left":46,"top":38,"rotate":0,"h":68,"w":68,"skewx":15,"skewy":15,"rotatex":0,"rotatey":-15,"maxh":50,"maxw":50}
        ]
    },
    {
        id:35,
        items:[
        {"left":10,"top":4,"rotate":0,"h":68,"w":68,"skewx":15,"skewy":15,"rotatex":0,"rotatey":-15,"maxh":50,"maxw":50},
        {"left":13,"top":7,"rotate":0,"h":68,"w":68,"skewx":15,"skewy":15,"rotatex":0,"rotatey":-15,"maxh":50,"maxw":50},
        {"left":17,"top":10,"rotate":0,"h":68,"w":68,"skewx":15,"skewy":15,"rotatex":0,"rotatey":-15,"maxh":50,"maxw":50},
        {"left":20,"top":14,"rotate":0,"h":68,"w":68,"skewx":15,"skewy":15,"rotatex":0,"rotatey":-15,"maxh":50,"maxw":50},
        {"left":24,"top":17,"rotate":0,"h":68,"w":68,"skewx":15,"skewy":15,"rotatex":0,"rotatey":-15,"maxh":50,"maxw":50},
        {"left":28,"top":21,"rotate":0,"h":68,"w":68,"skewx":15,"skewy":15,"rotatex":0,"rotatey":-15,"maxh":50,"maxw":50},
        {"left":31,"top":24,"rotate":0,"h":68,"w":68,"skewx":15,"skewy":15,"rotatex":0,"rotatey":-15,"maxh":50,"maxw":50},
        {"left":35,"top":27,"rotate":0,"h":68,"w":68,"skewx":15,"skewy":15,"rotatex":0,"rotatey":-15,"maxh":50,"maxw":50},
        {"left":38,"top":31,"rotate":0,"h":68,"w":68,"skewx":15,"skewy":15,"rotatex":0,"rotatey":-15,"maxh":50,"maxw":50},
        {"left":42,"top":34,"rotate":0,"h":68,"w":68,"skewx":15,"skewy":15,"rotatex":0,"rotatey":-15,"maxh":50,"maxw":50},
        {"left":46,"top":38,"rotate":0,"h":68,"w":68,"skewx":15,"skewy":15,"rotatex":0,"rotatey":-15,"maxh":50,"maxw":50}
        ]
    },
    {
        id:36,
        items:[
        {"left":0,"top":0,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":0,"rotatey":0,"maxh":60,"maxw":60},
        {"left":3,"top":3,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":0,"rotatey":0,"maxh":60,"maxw":60},
        {"left":6,"top":6,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":0,"rotatey":0,"maxh":60,"maxw":60},
        {"left":9,"top":9,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":0,"rotatey":0,"maxh":60,"maxw":60},
        {"left":12,"top":12,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":0,"rotatey":0,"maxh":60,"maxw":60},
        {"left":15,"top":15,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":0,"rotatey":0,"maxh":60,"maxw":60},
        {"left":18,"top":18,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":0,"rotatey":0,"maxh":60,"maxw":60},
        {"left":21,"top":21,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":0,"rotatey":0,"maxh":60,"maxw":60},
        {"left":24,"top":24,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":0,"rotatey":0,"maxh":60,"maxw":60},
        {"left":27,"top":27,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":0,"rotatey":0,"maxh":60,"maxw":60},
        {"left":30,"top":30,"rotate":0,"h":60,"w":60,"skewx":0,"skewy":0,"rotatex":0,"rotatey":0,"maxh":60,"maxw":60}
        ]
    }
]
export default function ABC(){
  const [on,setOn]=useState(false)
  const [diX,setDiX]=useState(0)
  const [dfX,setDfX]=useState(0)
  const [diY,setDiY]=useState(0)
  const [dfY,setDfY]=useState(0)
  const [pattern,setPattern]=useState(0)
  const [patternX,setPatternX]=useState(0)
  const [patternY,setPatternY]=useState(0)
  const [patternZ,setPatternZ]=useState(0)
  const data1={
    "x-label":[-15,-10,-5,0,5,10,15],
    "y-label":[15,10,5,0,-5,-10,-15],
    "max":15,
    item:[
  // x:age(min-max), y:salary(USDK min-max), z:creditscore
  { x: 5.294117647058823, y: 5.181478672602063, z: 6 },
  { x: 5, y: 5.784067645951133, z: 6 },
  { x: 5.294117647058823, y: 5.858840961127717, z: 5 },
  { x: 4.411764705882353, y: 4.776534382083733, z: 6 },
  { x: 5.588235294117647, y: 3.9829017121651304, z: 8 },
  { x: 5.882352941176471, y: 7.787410990044579, z: 6 },
  { x: 7.647058823529411, y: 0.2672871873683113, z: 8 },
  { x: 1.4705882352941178, y: 6.150362628964711, z: 3 },
  { x: 5.882352941176471, y: 3.75983984075807, z: 5 },
  { x: 0.8823529411764707, y: 3.5867795520373265, z: 6 },
  { x: 2.0588235294117645, y: 4.041957444902598, z: 5 },
  { x: 0, y: 3.8378711210996204, z: 4 },
  { x: 2.9411764705882355, y: 1.1392816714373353, z: 4 },
  { x: 0.29411764705882354, y: 10, z: 5 },
  { x: 3.235294117647059, y: 3.2759442661858746, z: 6 },
  { x: 6.176470588235294, y: 3.1884986939069595, z: 6 },
  { x: 10, y: 0, z: 6 }
    ]
  }
  const [text1, setText1] = useState(JSON.stringify(data1.item))
  const [text1View, setText1View] = useState(data1.item)

  const onMouse2Start=(e)=>{
    setDiX(0)
    setDiY(0)
    setOn(true)
    setDiX(e.clientX)
    setDiY(e.clientY)
  }
  const onMouse2Move=(e)=>{
    if(on){
      setDfX(diX-e.clientX)
      setDfY(diY-e.clientY)
      if(Math.abs(dfX)>Math.abs(dfY)){
         onChange2RoutineX1(diX-e.clientX)
      }else if(Math.abs(Math.abs(dfX)-Math.abs(dfY))<10){
        onChange2RoutineZ1(Math.floor(Math.sqrt(dfX*dfX+dfY*dfY)))
      }else{
        onChange2RoutineY1(diY-e.clientY)
      }
    }
  }
  const onMouse2End=(e)=>{
    setOn(false) 
  }
  const onChange2RoutineX1=(x) => {
    setPatternX(x)
    if(x>12){
      setPattern(x%13) 
    }else{
      setPattern(x)
    }
  }
  const onChange2RoutineY1=(x) => {
    setPatternY(x) 
    const remain12=(Number(x)-(12*(Math.floor(Number(x)/12)-1)))%12
    setPattern(remain12+13)
  }
  const onChange2RoutineZ1=(x) => {
    setPatternZ(x)
    const remain11=(Number(x)-(11*(Math.floor(Number(x)/11)-1)))%11
    setPattern(remain11+25)
  }
  const onClick2Back=()=>{
    if(pattern>0){
    setPattern(pattern-1)
  }else{
    setPattern(data1_plate.length-1)
  }
  }
  const onClick2Next=()=>{
  if(pattern<data1_plate.length-1){
    setPattern(pattern+1)
  }else{
    setPattern(0)
  }
  }
  return (<>
  <b className='text-[9px]'>3D plot(+/+/+)</b>
  <div className='flex'>
  <div className='flex-col'>
  <div className='text-[9px] font-bold flex mb-1 justify-between w-[180px]'>
  <div onClick={onClick2Back} className='border border-gray-800 cursor-default pl-[2px] pr-[2px] hover:bg-gray-200 mr-[4px]'>back</div> <div className='border border-gray-800 cursor-default pl-[2px] pr-[2px] hover:bg-gray-200' onClick={onClick2Next}>next</div></div>
  <div className='flex w-[200px] relative h-[193px]'>
  <div className='absolute z-[20] w-[180px] h-[180px]' onMouseDown={onMouse2Start} onMouseMove={onMouse2Move} onMouseUp={onMouse2End}></div>
  <div className='relative'>
  {/* line */}
  <div className='absolute z-[0] top-[0px] w-[180px] h-[180px] flex flex-col justify-between'>
  {data1['x-label'].map((x,i)=><>{i==data1['x-label'].length-1?<div className='w-full border-t border-gray-200'></div>:<><div className='w-full border-t border-gray-200'></div>
  <div className='w-full border-t border-gray-100'></div>
  <div className='w-full border-t border-gray-100'></div>
  <div className='w-full border-t border-gray-100'></div>
  <div className='w-full border-t border-gray-100'></div> 
  </>}</>)}
  </div>
  <div className='absolute z-[1] w-[180px] h-[178px] flex justify-between'>
  {data1['y-label'].map((x,i)=><>{i==data1['y-label'].length-1?<div className='h-full border-r border-gray-200'></div>:<><div className='h-full border-r border-gray-200'></div>
  <div className='h-full border-r border-gray-100'></div>
  <div className='h-full border-r border-gray-100'></div>
  <div className='h-full border-r border-gray-100'></div>
  <div className='h-full border-r border-gray-100'></div> 
  </>}</>)}
  </div>
  {/* mein line */}
  <div className={`absolute z-[2] top-[89.5px] left-0 w-[180px] border-b border-gray-300`}></div>
  <div className='absolute z-[2] top-0 left-[89.5px] h-[180px] border-r border-gray-300'></div>
  {/* label */}
  <div className='absolute z-[2] w-[180px] top-[88px] left-0 flex justify-between'>{data1['x-label'].map((x,i)=>
  <div className='relative border-l border-gray-300 w-[1px] h-[4px]'><div className='absolute z-[2] text-[6px] top-[4px] left-[-4px]'>{x}</div></div>
  )}</div>
  <div className='absolute z-[2] h-[180px] top-0 left-[88px] flex flex-col justify-between'>{data1['y-label'].map((x,i)=>
  <div className='relative border-t border-gray-300 h-[1px] w-[4px]'><div className='absolute text-[6px] top-[-5px] left-[6px]'>{x}</div></div>)}
  </div>
  {/* lines */}
  <div className={`absolute z-[3] top-[30px] left-[90px] border-r border-gray-800 w-[1px] h-[60px] origin-bottom-left`} style={{top:`${data1_line[`${pattern}`].plate.filter((x)=>x.place=='y-point')[0].top}px`,left:`${data1_line[`${pattern}`].plate.filter((x)=>x.place=='y-point')[0].left}px`,transform:`rotate(${data1_line[`${pattern}`].plate.filter((x)=>x.place=='y-point')[0].rotate}deg)`,height:`${data1_line[`${pattern}`].plate.filter((x)=>x.place=='y-point')[0].h}px`,width:`${data1_line[`${pattern}`].plate.filter((x)=>x.place=='y-point')[0].w}px`}}></div>
  <div className={`absolute z-[3] border-b border-gray-800 origin-top-left`} style={{top:`${data1_line[`${pattern}`].plate.filter((x)=>x.place=='x-bottom')[0].top}px`,left:`${data1_line[`${pattern}`].plate.filter((x)=>x.place=='x-bottom')[0].left}px`,transform:`rotate(${data1_line[`${pattern}`].plate.filter((x)=>x.place=='x-bottom')[0].rotate}deg)`,height:`${data1_line[`${pattern}`].plate.filter((x)=>x.place=='x-bottom')[0].h}px`,width:`${data1_line[`${pattern}`].plate.filter((x)=>x.place=='x-bottom')[0].w}px`}}></div> 
  <div className={`absolute z-[3] border-b border-gray-800 origin-top-left`} style={{top:`${data1_line[`${pattern}`].plate.filter((x)=>x.place=='x-top')[0].top}px`,left:`${data1_line[`${pattern}`].plate.filter((x)=>x.place=='x-top')[0].left}px`,transform:`rotate(${data1_line[`${pattern}`].plate.filter((x)=>x.place=='x-top')[0].rotate}deg)`,height:`${data1_line[`${pattern}`].plate.filter((x)=>x.place=='x-top')[0].h}px`,width:`${data1_line[`${pattern}`].plate.filter((x)=>x.place=='x-top')[0].w}px`}}></div>
  <div className={`absolute z-[3] border-r border-gray-800 w-[1px] h-[60px] origin-bottom-left`} style={{top:`${data1_line[`${pattern}`].plate.filter((x)=>x.place=='y-side')[0].top}px`,left:`${data1_line[`${pattern}`].plate.filter((x)=>x.place=='y-side')[0].left}px`,transform:`rotate(${data1_line[`${pattern}`].plate.filter((x)=>x.place=='y-side')[0].rotate}deg)`,height:`${data1_line[`${pattern}`].plate.filter((x)=>x.place=='y-side')[0].h}px`,width:`${data1_line[`${pattern}`].plate.filter((x)=>x.place=='y-side')[0].w}px`}}></div> 
  <div className={`absolute z-[3] border-r border-gray-800 origin-bottom-left`} style={{top:`${data1_line[`${pattern}`].plate.filter((x)=>x.place=='y2-point')[0].top}px`,left:`${data1_line[`${pattern}`].plate.filter((x)=>x.place=='y2-point')[0].left}px`,transform:`rotate(${data1_line[`${pattern}`].plate.filter((x)=>x.place=='y2-point')[0].rotate}deg)`,height:`${data1_line[`${pattern}`].plate.filter((x)=>x.place=='y2-point')[0].h}px`,width:`${data1_line[`${pattern}`].plate.filter((x)=>x.place=='y2-point')[0].w}px`}}></div>
  <div className={`absolute z-[3] border-b border-gray-800 origin-top-left`} style={{top:`${data1_line[`${pattern}`].plate.filter((x)=>x.place=='x2-bottom')[0].top}px`,left:`${data1_line[`${pattern}`].plate.filter((x)=>x.place=='x2-bottom')[0].left}px`,transform:`rotate(${data1_line[`${pattern}`].plate.filter((x)=>x.place=='x2-bottom')[0].rotate}deg)`,height:`${data1_line[`${pattern}`].plate.filter((x)=>x.place=='x2-bottom')[0].h}px`,width:`${data1_line[`${pattern}`].plate.filter((x)=>x.place=='x2-bottom')[0].w}px`}}></div>
  <div className={`absolute z-[3] border-b border-gray-800 origin-top-left`} style={{top:`${data1_line[`${pattern}`].plate.filter((x)=>x.place=='x2-top')[0].top}px`,left:`${data1_line[`${pattern}`].plate.filter((x)=>x.place=='x2-top')[0].left}px`,transform:`rotate(${data1_line[`${pattern}`].plate.filter((x)=>x.place=='x2-top')[0].rotate}deg)`,height:`${data1_line[`${pattern}`].plate.filter((x)=>x.place=='x2-top')[0].h}px`,width:`${data1_line[`${pattern}`].plate.filter((x)=>x.place=='x2-top')[0].w}px`}}></div>
  <div className={`absolute z-[3] border-r border-gray-800 w-[1px] h-[60px] origin-bottom-left`} style={{top:`${data1_line[`${pattern}`].plate.filter((x)=>x.place=='y2-side')[0].top}px`,left:`${data1_line[`${pattern}`].plate.filter((x)=>x.place=='y2-side')[0].left}px`,transform:`rotate(${data1_line[`${pattern}`].plate.filter((x)=>x.place=='y2-side')[0].rotate}deg)`,height:`${data1_line[`${pattern}`].plate.filter((x)=>x.place=='y2-side')[0].h}px`,width:`${data1_line[`${pattern}`].plate.filter((x)=>x.place=='y2-side')[0].w}px`}}></div>  
  <div className={`absolute z-[3] rotate-[-45deg] top-[90px] left-[90px] w-[43px] h-[1px] bg-gray-800 origin-top-left`}  style={{top:`${data1_line[`${pattern}`].plate.filter((x)=>x.place=='x3-bottom')[0].top}px`,left:`${data1_line[`${pattern}`].plate.filter((x)=>x.place=='x3-bottom')[0].left}px`,transform:`rotate(${data1_line[`${pattern}`].plate.filter((x)=>x.place=='x3-bottom')[0].rotate}deg)`,height:`${data1_line[`${pattern}`].plate.filter((x)=>x.place=='x3-bottom')[0].h}px`,width:`${data1_line[`${pattern}`].plate.filter((x)=>x.place=='x3-bottom')[0].w}px`}}></div>
  <div className={`absolute z-[3] rotate-[-45deg] top-[30px] left-[90px] w-[43px] h-[1px] bg-gray-800 origin-top-left`} style={{top:`${data1_line[`${pattern}`].plate.filter((x)=>x.place=='x3-top')[0].top}px`,left:`${data1_line[`${pattern}`].plate.filter((x)=>x.place=='x3-top')[0].left}px`,transform:`rotate(${data1_line[`${pattern}`].plate.filter((x)=>x.place=='x3-top')[0].rotate}deg)`,height:`${data1_line[`${pattern}`].plate.filter((x)=>x.place=='x3-top')[0].h}px`,width:`${data1_line[`${pattern}`].plate.filter((x)=>x.place=='x3-top')[0].w}px`}}></div>
  <div className={`absolute z-[3] rotate-[-45deg] top-[30px] left-[150px] w-[43px] h-[1px] bg-gray-800 origin-top-left`} style={{top:`${data1_line[`${pattern}`].plate.filter((x)=>x.place=='x4-bottom')[0].top}px`,left:`${data1_line[`${pattern}`].plate.filter((x)=>x.place=='x4-bottom')[0].left}px`,transform:`rotate(${data1_line[`${pattern}`].plate.filter((x)=>x.place=='x4-bottom')[0].rotate}deg)`,height:`${data1_line[`${pattern}`].plate.filter((x)=>x.place=='x4-bottom')[0].h}px`,width:`${data1_line[`${pattern}`].plate.filter((x)=>x.place=='x4-bottom')[0].w}px`}}></div>
  <div className={`absolute z-[3] rotate-[-45deg] top-[90px] left-[150px] w-[43px] h-[1px] bg-gray-800 origin-top-left`} style={{top:`${data1_line[`${pattern}`].plate.filter((x)=>x.place=='x4-top')[0].top}px`,left:`${data1_line[`${pattern}`].plate.filter((x)=>x.place=='x4-top')[0].left}px`,transform:`rotate(${data1_line[`${pattern}`].plate.filter((x)=>x.place=='x4-top')[0].rotate}deg)`,height:`${data1_line[`${pattern}`].plate.filter((x)=>x.place=='x4-top')[0].h}px`,width:`${data1_line[`${pattern}`].plate.filter((x)=>x.place=='x4-top')[0].w}px`}}></div>
  </div>
  {/* mouse bg-purple-800*/}
  <div className='opacity-[.2] w-[180px] h-[180px]'> </div>
  {/* z 0 bg-purple-800 opacity-[.6] opacity-[.8]*/}
  <div className='absolute z-[16] origin-top-left'
  style={{left:`${120-(data1_plate[pattern].items[10].left)}px`,top:`${data1_plate[pattern].items[10].top}px`,rotate:`${data1_plate[pattern].items[10].rotate}deg`,
  transform: `skewX(${data1_plate[pattern].items[10].skewx}deg) skewY(${data1_plate[pattern].items[10].skewy}deg)  rotateX(${data1_plate[pattern].items[10].rotatex}deg) rotateY(${data1_plate[pattern].items[10].rotatey}deg)`,width:`${120-(data1_plate[pattern].items[10].w)}px`,
  height:`${120-(data1_plate[pattern].items[10].h)}px`}}
  >
  <div className='relative'
  style={{
  width:`${120-(data1_plate[pattern].items[10].w)}px`,
  height:`${120-(data1_plate[pattern].items[10].h)}px`}}>
  {text1View.map(x=>x.z==0?<div className='absolute w-[6px] h-[6px] bg-purple-800 opacity-[.3] rounded-full' 
  style={{left:`${x.x>0?((data1_plate[pattern].items[10].maxw/10)*x.x)-2:0-2}px`,top:`${x.y>0?(data1_plate[pattern].items[10].maxh)-((data1_plate[pattern].items[10].maxh/10)*x.y)-2:data1_plate[pattern].items[10].maxh-2}px`}}
  >
  </div>:'')}
  </div>
  </div>
  {/* z 1 */}
  <div className='absolute z-[15] origin-top-left'
  style={{left:`${120-(data1_plate[pattern].items[9].left)}px`,top:`${data1_plate[pattern].items[9].top}px`,rotate:`${data1_plate[pattern].items[9].rotate}deg`,
  transform: `skewX(${data1_plate[pattern].items[9].skewx}deg) skewY(${data1_plate[pattern].items[9].skewy}deg)  rotateX(${data1_plate[pattern].items[9].rotatex}deg) rotateY(${data1_plate[pattern].items[9].rotatey}deg)`,width:`${120-(data1_plate[pattern].items[9].w)}px`,
  height:`${120-(data1_plate[pattern].items[9].h)}px`}}
  >
  <div className='relative'
  style={{
  width:`${120-(data1_plate[pattern].items[9].w)}px`,
  height:`${120-(data1_plate[pattern].items[9].h)}px`}}>
  {text1View.map(x=>x.z==1?<div className='absolute w-[6px] h-[6px] bg-purple-800 opacity-[.3] rounded-full' 
  style={{left:`${x.x>0?((data1_plate[pattern].items[9].maxw/10)*x.x)-2:0-2}px`,top:`${x.y>0?(data1_plate[pattern].items[9].maxh)-((data1_plate[pattern].items[9].maxh/10)*x.y)-2:data1_plate[pattern].items[9].maxh-2}px`}}
  ></div>:'')}
  </div>
  </div>
  {/* z 2 */}
  <div className='absolute z-[14] origin-top-left'
  style={{left:`${120-(data1_plate[pattern].items[8].left)}px`,top:`${data1_plate[pattern].items[8].top}px`,rotate:`${data1_plate[pattern].items[8].rotate}deg`,
  transform: `skewX(${data1_plate[pattern].items[8].skewx}deg) skewY(${data1_plate[pattern].items[8].skewy}deg)  rotateX(${data1_plate[pattern].items[8].rotatex}deg) rotateY(${data1_plate[pattern].items[8].rotatey}deg)`,width:`${120-(data1_plate[pattern].items[8].w)}px`,
  height:`${120-(data1_plate[pattern].items[8].h)}px`}}
  >
  <div className='relative'
  style={{
  width:`${120-(data1_plate[pattern].items[8].w)}px`,
  height:`${120-(data1_plate[pattern].items[8].h)}px`}}>
  {text1View.map(x=>x.z==2?<div className='absolute w-[6px] h-[6px] bg-purple-800 opacity-[.3] rounded-full' 
  style={{left:`${x.x>0?((data1_plate[pattern].items[8].maxw/10)*x.x)-2:0-2}px`,top:`${x.y>0?(data1_plate[pattern].items[8].maxh)-((data1_plate[pattern].items[8].maxh/10)*x.y)-2:data1_plate[pattern].items[8].maxh-2}px`}}
  ></div>:'')}
  </div>
  </div>
  {/* z 3 */}
  <div className='absolute z-[13] origin-top-left '
  style={{left:`${120-(data1_plate[pattern].items[7].left)}px`,top:`${data1_plate[pattern].items[7].top}px`,rotate:`${data1_plate[pattern].items[7].rotate}deg`,
  transform: `skewX(${data1_plate[pattern].items[7].skewx}deg) skewY(${data1_plate[pattern].items[7].skewy}deg)  rotateX(${data1_plate[pattern].items[7].rotatex}deg) rotateY(${data1_plate[pattern].items[7].rotatey}deg)`,width:`${120-(data1_plate[pattern].items[7].w)}px`,
  height:`${120-(data1_plate[pattern].items[7].h)}px`}}
  >
  <div className='relative'
  style={{
    width:`${120-(data1_plate[pattern].items[7].w)}px`,
    height:`${120-(data1_plate[pattern].items[7].h)}px`}}>
    {text1View.map(x=>x.z==3?<div className='absolute w-[6px] h-[6px] bg-purple-800 opacity-[.3] rounded-full' 
    style={{left:`${x.x>0?((data1_plate[pattern].items[7].maxw/10)*x.x)-2:0-2}px`,top:`${x.y>0?(data1_plate[pattern].items[7].maxh)-((data1_plate[pattern].items[7].maxh/10)*x.y)-2:data1_plate[pattern].items[7].maxh-2}px`}}
    ></div>:'')}
  </div>
  </div>
  {/* z 4 */}
  <div className='absolute z-[12] origin-top-left'
  style={{left:`${120-(data1_plate[pattern].items[6].left)}px`,top:`${data1_plate[pattern].items[6].top}px`,rotate:`${data1_plate[pattern].items[6].rotate}deg`,
  transform: `skewX(${data1_plate[pattern].items[6].skewx}deg) skewY(${data1_plate[pattern].items[6].skewy}deg)  rotateX(${data1_plate[pattern].items[6].rotatex}deg) rotateY(${data1_plate[pattern].items[6].rotatey}deg)`,width:`${120-(data1_plate[pattern].items[6].w)}px`,
  height:`${120-(data1_plate[pattern].items[6].h)}px`}}
  >
  <div className='relative'
  style={{
    width:`${120-(data1_plate[pattern].items[6].w)}px`,
    height:`${120-(data1_plate[pattern].items[6].h)}px`}}>
    {text1View.map(x=>x.z==4?<div className='absolute w-[6px] h-[6px] bg-purple-800 opacity-[.3] rounded-full' 
    style={{left:`${x.x>0?((data1_plate[pattern].items[6].maxw/10)*x.x)-2:0-2}px`,top:`${x.y>0?(data1_plate[pattern].items[6].maxh)-((data1_plate[pattern].items[6].maxh/10)*x.y)-2:data1_plate[pattern].items[6].maxh-2}px`}}
    ></div>:'')}
  </div>
  </div>  
  {/* z 5 */}
  <div className='absolute z-[11] origin-top-left'
  style={{left:`${120-(data1_plate[pattern].items[5].left)}px`,top:`${data1_plate[pattern].items[5].top}px`,rotate:`${data1_plate[pattern].items[5].rotate}deg`,
  transform: `skewX(${data1_plate[pattern].items[5].skewx}deg) skewY(${data1_plate[pattern].items[5].skewy}deg)  rotateX(${data1_plate[pattern].items[5].rotatex}deg) rotateY(${data1_plate[pattern].items[5].rotatey}deg)`,width:`${120-(data1_plate[pattern].items[5].w)}px`,
  height:`${120-(data1_plate[pattern].items[5].h)}px`}}
  >
  <div className='relative'
  style={{
  width:`${120-(data1_plate[pattern].items[5].w)}px`,
  height:`${120-(data1_plate[pattern].items[5].h)}px`}}>
  {text1View.map(x=>x.z==5?<div className='absolute w-[6px] h-[6px] bg-purple-800 opacity-[.3] rounded-full' 
  style={{left:`${x.x>0?((data1_plate[pattern].items[5].maxw/10)*x.x)-2:0-2}px`,top:`${x.y>0?(data1_plate[pattern].items[5].maxh)-((data1_plate[pattern].items[5].maxh/10)*x.y)-2:data1_plate[pattern].items[5].maxh-2}px`}}
  ></div>:'')}
  </div>
  </div>   
  {/* z 6 */}
  <div className='absolute z-[10] origin-top-left'
  style={{left:`${120-(data1_plate[pattern].items[4].left)}px`,top:`${data1_plate[pattern].items[4].top}px`,rotate:`${data1_plate[pattern].items[4].rotate}deg`,
  transform: `skewX(${data1_plate[pattern].items[4].skewx}deg) skewY(${data1_plate[pattern].items[4].skewy}deg)  rotateX(${data1_plate[pattern].items[4].rotatex}deg) rotateY(${data1_plate[pattern].items[4].rotatey}deg)`,width:`${120-(data1_plate[pattern].items[4].w)}px`,
  height:`${120-(data1_plate[pattern].items[4].h)}px`}}
  >
  <div className='relative'
  style={{
  width:`${120-(data1_plate[pattern].items[4].w)}px`,
  height:`${120-(data1_plate[pattern].items[4].h)}px`}}>
  {text1View.map(x=>x.z==6?<div className='absolute w-[6px] h-[6px] bg-purple-800 opacity-[.3] rounded-full' 
  style={{left:`${x.x>0?((data1_plate[pattern].items[4].maxw/10)*x.x)-2:0-2}px`,top:`${x.y>0?(data1_plate[pattern].items[4].maxh)-((data1_plate[pattern].items[4].maxh/10)*x.y)-2:data1_plate[pattern].items[4].maxh-2}px`}}
  ></div>:'')}
  </div>
  </div>  
  {/* z 7 */}
  <div className='absolute z-[9] origin-top-left'
  style={{left:`${120-(data1_plate[pattern].items[3].left)}px`,top:`${data1_plate[pattern].items[3].top}px`,rotate:`${data1_plate[pattern].items[3].rotate}deg`,
  transform: `skewX(${data1_plate[pattern].items[3].skewx}deg) skewY(${data1_plate[pattern].items[3].skewy}deg)  rotateX(${data1_plate[pattern].items[3].rotatex}deg) rotateY(${data1_plate[pattern].items[3].rotatey}deg)`,width:`${120-(data1_plate[pattern].items[3].w)}px`,
  height:`${120-(data1_plate[pattern].items[3].h)}px`}}
  >
  <div className='relative'
  style={{
  width:`${120-(data1_plate[pattern].items[3].w)}px`,
  height:`${120-(data1_plate[pattern].items[3].h)}px`}}>
  {text1View.map(x=>x.z==7?<div className='absolute w-[6px] h-[6px] bg-purple-800 opacity-[.3] rounded-full' 
  style={{left:`${x.x>0?((data1_plate[pattern].items[3].maxw/10)*x.x)-2:0-2}px`,top:`${x.y>0?(data1_plate[pattern].items[3].maxh)-((data1_plate[pattern].items[3].maxh/10)*x.y)-2:data1_plate[pattern].items[3].maxh-2}px`}}
  ></div>:'')}
  </div>
  </div>  
  {/* z 8 */}
   <div className='absolute z-[8] origin-top-left'
  style={{left:`${120-(data1_plate[pattern].items[2].left)}px`,top:`${data1_plate[pattern].items[2].top}px`,rotate:`${data1_plate[pattern].items[2].rotate}deg`,
  transform: `skewX(${data1_plate[pattern].items[2].skewx}deg) skewY(${data1_plate[pattern].items[2].skewy}deg)  rotateX(${data1_plate[pattern].items[2].rotatex}deg) rotateY(${data1_plate[pattern].items[2].rotatey}deg)`,width:`${120-(data1_plate[pattern].items[2].w)}px`,
  height:`${120-(data1_plate[pattern].items[2].h)}px`}}
  >
  <div className='relative'
  style={{
  width:`${120-(data1_plate[pattern].items[2].w)}px`,
  height:`${120-(data1_plate[pattern].items[2].h)}px`}}>
  {text1View.map(x=>x.z==8?<div className='absolute w-[6px] h-[6px] bg-purple-800 opacity-[.3] rounded-full' 
  style={{left:`${x.x>0?((data1_plate[pattern].items[2].maxw/10)*x.x)-2:0-2}px`,top:`${x.y>0?(data1_plate[pattern].items[2].maxh)-((data1_plate[pattern].items[2].maxh/10)*x.y)-2:data1_plate[pattern].items[2].maxh-2}px`}}
  ></div>:'')}
  </div>
  </div>  
  {/* z 9 */}
   <div className='absolute z-[7] origin-top-left'
  style={{left:`${120-(data1_plate[pattern].items[1].left)}px`,top:`${data1_plate[pattern].items[1].top}px`,rotate:`${data1_plate[pattern].items[1].rotate}deg`,
  transform: `skewX(${data1_plate[pattern].items[1].skewx}deg) skewY(${data1_plate[pattern].items[1].skewy}deg)  rotateX(${data1_plate[pattern].items[1].rotatex}deg) rotateY(${data1_plate[pattern].items[1].rotatey}deg)`,width:`${120-(data1_plate[pattern].items[1].w)}px`,
  height:`${120-(data1_plate[pattern].items[1].h)}px`
}}
  >
  <div className='relative'
  style={{
  width:`${120-(data1_plate[pattern].items[1].w)}px`,
  height:`${120-(data1_plate[pattern].items[1].h)}px`}}>
  {text1View.map(x=>x.z==9?<div className='absolute w-[6px] h-[6px] bg-purple-800 opacity-[.3] rounded-full' 
  style={{left:`${x.x>0?((data1_plate[pattern].items[1].maxw/10)*x.x)-2:0-2}px`,top:`${x.y>0?(data1_plate[pattern].items[1].maxh)-((data1_plate[pattern].items[1].maxh/10)*x.y)-2:data1_plate[pattern].items[1].maxh-2}px`}}
  ></div>:'')}
  </div>
  </div>
  {/* z 10  */}
  <div className='absolute z-[6] origin-top-left'
  style={{left:`${120-(data1_plate[pattern].items[0].left)}px`,top:`${data1_plate[pattern].items[0].top}px`,rotate:`${data1_plate[pattern].items[0].rotate}deg`,
  transform: `skewX(${data1_plate[pattern].items[0].skewx}deg) skewY(${data1_plate[pattern].items[0].skewy}deg)  rotateX(${data1_plate[pattern].items[0].rotatex}deg) rotateY(${data1_plate[pattern].items[0].rotatey}deg)`,width:`${120-(data1_plate[pattern].items[0].w)}px`,
  height:`${120-(data1_plate[pattern].items[0].h)}px`
  }}
  >
  <div className='relative'
  style={{
  width:`${120-(data1_plate[pattern].items[0].w)}px`,
  height:`${120-(data1_plate[pattern].items[0].h)}px`}}>
  {text1View.map(x=>x.z==10?<div className='absolute w-[6px] h-[6px] bg-purple-800 opacity-[.3] rounded-full' 
  style={{left:`${x.x>0?((data1_plate[pattern].items[0].maxw/10)*x.x)-2:0-2}px`,top:`${x.y>0?(data1_plate[pattern].items[0].maxh)-((data1_plate[pattern].items[0].maxh/10)*x.y)-2:data1_plate[pattern].items[0].maxh-2}px`}}
  ></div>:'')}
  </div>
  </div>
  </div>
  </div>
  <div className='flex flex-col'>
    <p className='text-[9px]'>json data:</p>
    <textarea
      className='text-input-width border border-gray-950 text-[9px] w-[150px] h-[70px] line-break'
      value={text1} placeholder='your data goes here' onChange={(e)=>setText1(e.target.value)} 
      rows='4'
    ></textarea>
    <button className='border border-gray-800 text-[9px] w-fit pl-[10px] pr-[10px] mt-[2px] hover:bg-gray-100' onClick={()=>setText1View(JSON.parse(text1))}>apply</button>
    <div className='text-[9px]'>
      view:<br/> {typeof text1View !='string' && text1View != ''?<>{text1View.map(x=><div>x:{x.x} y:{x.y} z:{x.z}</div>)}</> :''}
    </div>
    </div>
  </div>
  </>)
}
